// TODO: should these be hardcoded here? Instead should these comes from database?
// e.g Going forward, if necessary to add new payment mode, just update in the database
// no need to build app if comes from database.
export default Object.freeze({
  COUNTRY_OF_BIRTH: [
    'Bangladesh', 'Cambodia', 'China', 'India', 'Indonesia', 'Malaysia', 'Myanmar', 'Philippines', 'Singapore', 'Sri Lanka', 'Vietnam',
    'Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Anguilla', 'Antigua & Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia & Herzegovina', 'Botswana', 'Brazil', 'British Virgin Islands', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cameroon', 'Canada', 'Cape Verde', 'Cayman Islands', 'Chad', 'Chile', 'Colombia', 'Congo', 'Cook Islands', 'Costa Rica', 'Cote D Ivoire', 'Croatia', 'Cruise Ship', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Estonia', 'Ethiopia', 'Falkland Islands', 'Faroe Islands', 'Fiji', 'Finland', 'France', 'French Polynesia', 'French West Indies', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guam', 'Guatemala', 'Guernsey', 'Guinea', 'Guinea Bissau', 'Guyana', 'Haiti', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'Iran', 'Iraq', 'Ireland', 'Isle of Man', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jersey', 'Jordan', 'Kazakhstan', 'Kenya', 'Kuwait', 'Kyrgyz Republic', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macau', 'Macedonia', 'Madagascar', 'Malawi', 'Maldives', 'Mali', 'Malta', 'Mauritania', 'Mauritius', 'Mexico', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Montserrat', 'Morocco', 'Mozambique', 'Namibia', 'Nepal', 'Netherlands', 'Netherlands Antilles', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Norway', 'Oman', 'Pakistan', 'Palestine', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Reunion', 'Romania', 'Russia', 'Rwanda', 'Saint Pierre & Miquelon', 'Samoa', 'San Marino', 'Satellite', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Slovakia', 'Slovenia', 'South Africa', 'South Korea', 'Spain', 'St Kitts & Nevis', 'St Lucia', 'St Vincent', 'St. Lucia', 'Sudan', 'Suriname', 'Swaziland', 'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', "Timor L'Este", 'Togo', 'Tonga', 'Trinidad & Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Turks & Caicos', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'United States Minor Outlying Islands', 'Uruguay', 'Uzbekistan', 'Venezuela', 'Virgin Islands (US)', 'Yemen', 'Zambia', 'Zimbabwe', 'Other',
  ],
  REFUND_REASONS: [
    'Product quality',
    'Product expired',
    'Damaged packing',
    'Change of mind',
    'Side effect',
    'Others',
  ],
  TITLE_OF_PERSON: [
    {
      label: '-',
      value: '-',
    },
    {
      label: 'general.mr',
      value: 'Mr.',
    },
    {
      label: 'general.mrs',
      value: 'Mrs.',
    },
    {
      label: 'general.ms',
      value: 'Ms.',
    },
    {
      label: 'general.mdm',
      value: 'Mdm',
    },
    {
      label: 'general.miss',
      value: 'MISS',
    },
    {
      label: 'general.dr',
      value: 'Dr',
    },
    {
      label: 'general.prof',
      value: 'Prof',
    },
    {
      label: 'patientTitles.master',
      value: 'Master',
    },
    {
      label: 'patientTitles.fieldMarshall',
      value: 'Field Marshall',
    },
    {
      label: 'patientTitles.general',
      value: 'General',
    },
    {
      label: 'patientTitles.lieutenantGeneral',
      value: 'Lieutenant General',
    },
    {
      label: 'patientTitles.majorGeneral',
      value: 'Major General',
    },
    {
      label: 'patientTitles.colonel',
      value: 'Colonel',
    },
    {
      label: 'patientTitles.lieutenantColonel',
      value: 'Lieutenant Colonel',
    },
    {
      label: 'patientTitles.major',
      value: 'Major',
    },
    {
      label: 'patientTitles.captain',
      value: 'Captain',
    },
    {
      label: 'patientTitles.lieutenant',
      value: 'Lieutenant',
    },
    {
      label: 'patientTitles.subLieutenant',
      value: 'Sub Lieutenant',
    },
    {
      label: 'patientTitles.sergeantMajorFirstClass',
      value: 'Sergeant Major First Class',
    },
    {
      label: 'patientTitles.sergeantMajorSecondClass',
      value: 'Sergeant Major Second Class',
    },
    {
      label: 'patientTitles.sergeantMajorThirdClass',
      value: 'Sergeant Major Third Class',
    },
    {
      label: 'patientTitles.sergeant',
      value: 'Sergeant',
    },
    {
      label: 'patientTitles.corporal',
      value: 'Corporal',
    },
    {
      label: 'patientTitles.privateFirstClass',
      value: 'Private First Class',
    },
    {
      label: 'patientTitles.private',
      value: 'Private',
    },
    {
      label: 'patientTitles.armyCadet',
      value: 'Army Cadet',
    },
    {
      label: 'patientTitles.armyNon-CommissionedOfficerStudent',
      value: 'Army Non-Commissioned Officer Student',
    },
    {
      label: 'patientTitles.actingMajor',
      value: 'Acting Major',
    },
    {
      label: 'patientTitles.actingCaptain',
      value: 'Acting Captain',
    },
    {
      label: 'patientTitles.actingLieutenant',
      value: 'Acting Lieutenant',
    },
    {
      label: 'patientTitles.actingSubLieutenant',
      value: 'Acting Sub. Lieutenant',
    },
    {
      label: 'patientTitles.reserveOfficerTrainingCopsStudent',
      value: 'Reserve Officer Training Cops Student',
    },
    {
      label: 'patientTitles.admiralOfTheFleet',
      value: 'Admiral of the Fleet',
    },
    {
      label: 'patientTitles.admiral',
      value: 'Admiral',
    },
    {
      label: 'patientTitles.viceAdmiral',
      value: 'Vice Admiral',
    },
    {
      label: 'patientTitles.rearAdmiral',
      value: 'Rear Admiral',
    },
    {
      label: 'patientTitles.captain2',
      value: 'Captain',
    },
    {
      label: 'patientTitles.commander',
      value: 'Commander',
    },
    {
      label: 'patientTitles.lieutenantCommander',
      value: 'Lieutenant Commander',
    },
    {
      label: 'patientTitles.lieutenant2',
      value: 'Lieutenant',
    },
    {
      label: 'patientTitles.lieutenantJuniorGrade',
      value: 'Lieutenant Junior Grade',
    },
    {
      label: 'patientTitles.subLieutenant2',
      value: 'Sub Lieutenant',
    },
    {
      label: 'patientTitles.chiefPettyOfficerFirstClass',
      value: 'Chief Petty Officer First Class',
    },
    {
      label: 'patientTitles.chiefPettyOfficerSecondClass',
      value: 'Chief Petty Officer Second Class',
    },
    {
      label: 'patientTitles.chiefPettyOfficerThirdClass',
      value: 'Chief Petty Officer Third Class',
    },
    {
      label: 'patientTitles.pettyOfficerFirstClass',
      value: 'Petty Officer First Class',
    },
    {
      label: 'patientTitles.pettyOfficerSecondClass',
      value: 'Petty Officer Second Class',
    },
    {
      label: 'patientTitles.pettyOfficerThirdClass',
      value: 'Petty Officer Third Class',
    },
    {
      label: 'patientTitles.seaman',
      value: 'Seaman',
    },
    {
      label: 'patientTitles.navalCadet',
      value: 'Naval Cadet',
    },
    {
      label: 'patientTitles.navalRatingStudent',
      value: 'Naval Rating Student',
    },
    {
      label: 'patientTitles.marshalOfTheRoyalThaiAirForce',
      value: 'Marshal of the Royal Thai Air Force',
    },
    {
      label: 'patientTitles.airChefMarshal',
      value: 'Air Chef Marshal',
    },
    {
      label: 'patientTitles.airMarshal',
      value: 'Air Marshal',
    },
    {
      label: 'patientTitles.airViceMarshal',
      value: 'Air Vice Marshal',
    },
    {
      label: 'patientTitles.groupCaptain',
      value: 'Group Captain',
    },
    {
      label: 'patientTitles.wingCommander',
      value: 'Wing Commander',
    },
    {
      label: 'patientTitles.squadronLeader',
      value: 'Squadron Leader',
    },
    {
      label: 'patientTitles.flightLieutenant',
      value: 'Flight Lieutenant',
    },
    {
      label: 'patientTitles.flyingOfficer',
      value: 'Flying Officer',
    },
    {
      label: 'patientTitles.pilotOfficer',
      value: 'Pilot Officer',
    },
    {
      label: 'patientTitles.flightSergeantFirstClass',
      value: 'Flight Sergeant First Class',
    },
    {
      label: 'patientTitles.flightSergeantSecondClass',
      value: 'Flight Sergeant Second Class',
    },
    {
      label: 'patientTitles.flightSergeantThirdClass',
      value: 'Flight Sergeant Third Class',
    },
    {
      label: 'patientTitles.sergeant2',
      value: 'Sergeant',
    },
    {
      label: 'patientTitles.corporal2',
      value: 'Corporal',
    },
    {
      label: 'patientTitles.leadingAircraftman',
      value: 'Leading Aircraftman',
    },
    {
      label: 'patientTitles.airman',
      value: 'Airman',
    },
    {
      label: 'patientTitles.airCadet',
      value: 'Air Cadet',
    },
    {
      label: 'patientTitles.airTechnicalStudent',
      value: 'Air Technical Student',
    },
    {
      label: 'patientTitles.policeGeneral',
      value: 'Police General',
    },
    {
      label: 'patientTitles.policeLieutenantGeneral',
      value: 'Police Lieutenant General',
    },
    {
      label: 'patientTitles.policeMajorGeneral',
      value: 'Police Major General',
    },
    {
      label: 'patientTitles.policeColonel',
      value: 'Police Colonel',
    },
    {
      label: 'patientTitles.policeLieutenantColonel',
      value: 'Police Lieutenant Colonel',
    },
    {
      label: 'patientTitles.policeMajor',
      value: 'Police Major',
    },
    {
      label: 'patientTitles.policeCaptain',
      value: 'Police Captain',
    },
    {
      label: 'patientTitles.policeLieutenant',
      value: 'Police Lieutenant',
    },
    {
      label: 'patientTitles.policeSub-Lieutenant',
      value: 'Police Sub-Lieutenant',
    },
    {
      label: 'patientTitles.policeSeniorSergeantMajor',
      value: 'Police Senior Sergeant Major',
    },
    {
      label: 'patientTitles.policeSergeantMajor',
      value: 'Police Sergeant Major',
    },
    {
      label: 'patientTitles.policeSergeant',
      value: 'Police Sergeant',
    },
    {
      label: 'patientTitles.policeCorporal',
      value: 'Police Corporal',
    },
    {
      label: 'patientTitles.policeLanceCorporal',
      value: 'Police Lance Corporal',
    },
    {
      label: 'patientTitles.samanera',
      value: 'SAMANERA',
    },
    {
      label: 'patientTitles.phraAthikan',
      value: 'PHRA ATHIKAN',
    },
    {
      label: 'patientTitles.phrapalad',
      value: 'PHRAPALAD',
    },
    {
      label: 'patientTitles.phrabaidika',
      value: 'PHRABAIDIKA',
    },
    {
      label: 'patientTitles.phrakhuSamu',
      value: 'PHRAKHU SAMU',
    },
    {
      label: 'patientTitles.phramaha',
      value: 'PHRAMAHA',
    },
    {
      label: 'patientTitles.phrakhuVinaidhorn',
      value: 'PHRAKHU VINAIDHORN',
    },
    {
      label: 'patientTitles.chaoAthikan',
      value: 'CHAO ATHIKAN',
    },
    {
      label: 'patientTitles.phrasamu',
      value: 'PHRASAMU',
    },
    {
      label: 'patientTitles.phrakhuPalad',
      value: 'PHRAKHU PALAD',
    },
    {
      label: 'patientTitles.phrakhuBaidika',
      value: 'PHRAKHU BAIDIKA',
    },
    {
      label: 'patientTitles.phrakhuDhammadhorn',
      value: 'PHRAKHU DHAMMADHORN',
    },
    {
      label: 'patientTitles.buddhistMonk',
      value: 'Buddhist Monk',
    },
    {
      label: 'patientTitles.rev',
      value: 'Rev.',
    },
    {
      label: 'patientTitles.momLuang',
      value: 'Mom Luang (M.L.)',
    },
    {
      label: 'patientTitles.momRajawong',
      value: 'Mom Rajawong (M.R.)',
    },
    {
      label: 'patientTitles.momChao',
      value: 'Mom Chao (M.C.)',
    },
    {
      label: 'patientTitles.emeritusProfessor',
      value: 'Emeritus Professor',
    },
    {
      label: 'patientTitles.professor',
      value: 'Professor',
    },
    {
      label: 'patientTitles.assistantProfessor',
      value: 'Assistant Professor',
    },
    {
      label: 'patientTitles.associateProfessor',
      value: 'Associate Professor',
    },
  ],
  LOCAL_TITLES_BGRIMM: [
    {
      value: '-',
      label: '-',
    },
    {
      value: 'นาย',
      label: 'นาย',
    },
    {
      value: 'นาง',
      label: 'นาง',
    },
    {
      value: 'นางสาว',
      label: 'นางสาว',
    },
    {
      value: 'เด็กหญิง',
      label: 'เด็กหญิง',
    },
    {
      value: 'เด็กชาย',
      label: 'เด็กชาย',
    },
    {
      value: 'จอมพล',
      label: 'จอมพล',
    },
    {
      value: 'พลเอก',
      label: 'พลเอก',
    },
    {
      value: 'พลโท',
      label: 'พลโท',
    },
    {
      value: 'พลตรี',
      label: 'พลตรี',
    },
    {
      value: 'พันเอก',
      label: 'พันเอก',
    },
    {
      value: 'พันโท',
      label: 'พันโท',
    },
    {
      value: 'พันตรี',
      label: 'พันตรี',
    },
    {
      value: 'ร้อยเอก',
      label: 'ร้อยเอก',
    },
    {
      value: 'ร้อยโท',
      label: 'ร้อยโท',
    },
    {
      value: 'ร้อยตรี',
      label: 'ร้อยตรี',
    },
    {
      value: 'จ่าสิบเอก',
      label: 'จ่าสิบเอก',
    },
    {
      value: 'จ่าสิบโท',
      label: 'จ่าสิบโท',
    },
    {
      value: 'จ่าสิบตรี',
      label: 'จ่าสิบตรี',
    },
    {
      value: 'สิบเอก',
      label: 'สิบเอก',
    },
    {
      value: 'สิบโท',
      label: 'สิบโท',
    },
    {
      value: 'สิบตรี',
      label: 'สิบตรี',
    },
    {
      value: 'พลทหาร',
      label: 'พลทหาร',
    },
    {
      value: 'นักเรียนนายร้อย',
      label: 'นักเรียนนายร้อย',
    },
    {
      value: 'นักเรียนนายสิบ',
      label: 'นักเรียนนายสิบ',
    },
    {
      value: 'ว่าที่พันตรี',
      label: 'ว่าที่พันตรี',
    },
    {
      value: 'ว่าที่ร้อยเอก',
      label: 'ว่าที่ร้อยเอก',
    },
    {
      value: 'ว่าที่ร้อยโท',
      label: 'ว่าที่ร้อยโท',
    },
    {
      value: 'ว่าที่ร้อยตรี',
      label: 'ว่าที่ร้อยตรี',
    },
    {
      value: 'นักศึกษาวิชาทหาร',
      label: 'นักศึกษาวิชาทหาร',
    },
    {
      value: 'จอมพลเรือ',
      label: 'จอมพลเรือ',
    },
    {
      value: 'พลเรือเอก',
      label: 'พลเรือเอก',
    },
    {
      value: 'พลเรือโท',
      label: 'พลเรือโท',
    },
    {
      value: 'พลเรือตรี',
      label: 'พลเรือตรี',
    },
    {
      value: 'นาวาเอก',
      label: 'นาวาเอก',
    },
    {
      value: 'นาวาโท',
      label: 'นาวาโท',
    },
    {
      value: 'นาวาตรี',
      label: 'นาวาตรี',
    },
    {
      value: 'เรือเอก',
      label: 'เรือเอก',
    },
    {
      value: 'เรือโท',
      label: 'เรือโท',
    },
    {
      value: 'เรือตรี',
      label: 'เรือตรี',
    },
    {
      value: 'พันจ่าเอก',
      label: 'พันจ่าเอก',
    },
    {
      value: 'พันจ่าโท',
      label: 'พันจ่าโท',
    },
    {
      value: 'พันจ่าตรี',
      label: 'พันจ่าตรี',
    },
    {
      value: 'จ่าเอก',
      label: 'จ่าเอก',
    },
    {
      value: 'จ่าโท',
      label: 'จ่าโท',
    },
    {
      value: 'จ่าตรี',
      label: 'จ่าตรี',
    },
    {
      value: 'พลทหาร',
      label: 'พลทหาร',
    },
    {
      value: 'นักเรียนทหารเรือ',
      label: 'นักเรียนทหารเรือ',
    },
    {
      value: 'นักเรียนจ่าทหารเรือ',
      label: 'นักเรียนจ่าทหารเรือ',
    },
    {
      value: 'จอมพลอากาศ',
      label: 'จอมพลอากาศ',
    },
    {
      value: 'พลอากาศเอก',
      label: 'พลอากาศเอก',
    },
    {
      value: 'พลอากาศโท',
      label: 'พลอากาศโท',
    },
    {
      value: 'พลอากาศตรี',
      label: 'พลอากาศตรี',
    },
    {
      value: 'นาวาอากาศเอก',
      label: 'นาวาอากาศเอก',
    },
    {
      value: 'นาวาอากาศโท',
      label: 'นาวาอากาศโท',
    },
    {
      value: 'นาวาอากาศตรี',
      label: 'นาวาอากาศตรี',
    },
    {
      value: 'เรืออากาศเอก',
      label: 'เรืออากาศเอก',
    },
    {
      value: 'เรืออากาศโท',
      label: 'เรืออากาศโท',
    },
    {
      value: 'เรืออากาศตรี',
      label: 'เรืออากาศตรี',
    },
    {
      value: 'พันจ่าอากาศเอก',
      label: 'พันจ่าอากาศเอก',
    },
    {
      value: 'พันจ่าอากาศโท',
      label: 'พันจ่าอากาศโท',
    },
    {
      value: 'พันจ่าอากาศตรี',
      label: 'พันจ่าอากาศตรี',
    },
    {
      value: 'จ่าอากาศเอก',
      label: 'จ่าอากาศเอก',
    },
    {
      value: 'จ่าอากาศโท',
      label: 'จ่าอากาศโท',
    },
    {
      value: 'จ่าอากาศตรี',
      label: 'จ่าอากาศตรี',
    },
    {
      value: 'พลทหาร',
      label: 'พลทหาร',
    },
    {
      value: 'นักเรีนนายเรืออากาศ',
      label: 'นักเรีนนายเรืออากาศ',
    },
    {
      value: 'นักเรียนจ่าอากาศ',
      label: 'นักเรียนจ่าอากาศ',
    },
    {
      value: 'พลตำรวจเอก',
      label: 'พลตำรวจเอก',
    },
    {
      value: 'พลตำรวจโท',
      label: 'พลตำรวจโท',
    },
    {
      value: 'พลตำรวจตรี',
      label: 'พลตำรวจตรี',
    },
    {
      value: 'พันตำรวจเอก',
      label: 'พันตำรวจเอก',
    },
    {
      value: 'พันตำรวจโท',
      label: 'พันตำรวจโท',
    },
    {
      value: 'พันตำรวจตรี',
      label: 'พันตำรวจตรี',
    },
    {
      value: 'ร้อยตำรวจเอก',
      label: 'ร้อยตำรวจเอก',
    },
    {
      value: 'ร้อยตำรวจโท',
      label: 'ร้อยตำรวจโท',
    },
    {
      value: 'ร้อยตำรวจตรี',
      label: 'ร้อยตำรวจตรี',
    },
    {
      value: 'ดาบตำรวจ',
      label: 'ดาบตำรวจ',
    },
    {
      value: 'จ่าสิบตำรวจ',
      label: 'จ่าสิบตำรวจ',
    },
    {
      value: 'สิบตำรวจเอก',
      label: 'สิบตำรวจเอก',
    },
    {
      value: 'สิบตำรวจโท',
      label: 'สิบตำรวจโท',
    },
    {
      value: 'สิบตำรวจตรี',
      label: 'สิบตำรวจตรี',
    },
    {
      value: 'สามเณร',
      label: 'สามเณร',
    },
    {
      value: 'พระอธิการ',
      label: 'พระอธิการ',
    },
    {
      value: 'พระปลัด',
      label: 'พระปลัด',
    },
    {
      value: 'พระใบฎีกา',
      label: 'พระใบฎีกา',
    },
    {
      value: 'พระครูสมุห์',
      label: 'พระครูสมุห์',
    },
    {
      value: 'พระมหา',
      label: 'พระมหา',
    },
    {
      value: 'พระครูวินัยธร',
      label: 'พระครูวินัยธร',
    },
    {
      value: 'เจ้าอธิการ',
      label: 'เจ้าอธิการ',
    },
    {
      value: 'พระสมุห์',
      label: 'พระสมุห์',
    },
    {
      value: 'พระครูปลัด',
      label: 'พระครูปลัด',
    },
    {
      value: 'พระครูใบฎีกา',
      label: 'พระครูใบฎีกา',
    },
    {
      value: 'พระครูธรรมธร',
      label: 'พระครูธรรมธร',
    },
    {
      value: 'พระสงฆ์',
      label: 'พระสงฆ์',
    },
    {
      value: 'บาทหลวง',
      label: 'บาทหลวง',
    },
    {
      value: 'หม่อมหลวง',
      label: 'หม่อมหลวง',
    },
    {
      value: 'หม่อมราชวงศ์',
      label: 'หม่อมราชวงศ์',
    },
    {
      value: 'หม่อมเจ้า',
      label: 'หม่อมเจ้า',
    },
    {
      value: 'ศาสตราจารย์เกียรติคุณ (กิตติคุณ)',
      label: 'ศาสตราจารย์เกียรติคุณ (กิตติคุณ)',
    },
    {
      value: 'ศาสตราจารย์',
      label: 'ศาสตราจารย์',
    },
    {
      value: 'ผู้ช่วยศาสตราจารย์',
      label: 'ผู้ช่วยศาสตราจารย์',
    },
    {
      value: 'รองศาสตราจารย์',
      label: 'รองศาสตราจารย์',
    },
  ],
  GENDER: {
    N: '', M: 'Male', F: 'Female', O: 'Other',
  },
  GENDERS: [
    { label: '-', value: '-' },
    { label: 'general.male', value: 'M' },
    { label: 'general.female', value: 'F' },
    { label: 'general.other', value: 'O' },
  ],
  NRIC_TYPES: [
    {
      value: 'nric',
      label: 'general.nric',
    },
    {
      value: 'passport',
      label: 'general.passport',
    },
  ],
  INVOICE_CATEGORY: [
    { label: '-', value: '-' },
    { label: 'general.consult', value: 'Consultation' },
    { label: 'general.prescriptionFormTitle', value: 'Prescription' },
    { label: 'nursingVentilation.therapy', value: 'Therapy' },
    { label: 'general.invTypeProduct', value: 'Product' },
    { label: 'general.invTypePackage', value: 'Package' },
    { label: 'general.invTypeLaboratory', value: 'Laboratory' },
    { label: 'general.invTypeExpendables', value: 'Expendables' },
    { label: 'general.invTypeWyn', value: 'Wyn' },
  ],
  MARITAL_STATUS: [
    { label: '-', value: '-' },
    { label: 'general.single', value: 'Single' },
    { label: 'general.married', value: 'Married' },
    { label: 'general.divorced', value: 'Divorced' },
    { label: 'general.separated', value: 'Separated' },
    { label: 'general.widowed', value: 'Widowed' },
    { label: 'general.priest', value: 'Priest' },
  ],
  VITALS_MAP: {
    height: 'Height',
    weight: 'Weight',
    bmi: 'BMI',
    waist: 'Waist Circumference',
    pulse: 'Pulse',
    systolic: 'Systolic',
    diastolic: 'Diastolic',
  },
  RACE: [
    { label: '-', value: '-' },
    { label: 'general.chineseRace', value: 'Chinese' },
    { label: 'general.malay', value: 'Malay' },
    { label: 'general.indian', value: 'Indian' },
    { label: 'general.caucasian', value: 'Caucasian' },
    { label: 'general.eurasian', value: 'Eurasian' },
    { label: 'general.others', value: 'Others' },
  ],
  NATIONALITY: [
    'Bangladeshi', 'Cambodian', 'Chinese', 'Filipino', 'Indian', 'Indonesian', 'Malaysian', 'Myanmarese', 'Singaporean', 'Sri Lankan', 'Vietnamese',
    'Afghan', 'Albanian', 'Algerian', 'American', 'Andorran', 'Angolan', 'Antiguans', 'Argentinean', 'Armenian', 'Australian', 'Austrian', 'Azerbaijani', 'Bahamian', 'Bahraini', 'Barbadian', 'Barbudans', 'Batswana', 'Belarusian', 'Belgian', 'Belizean', 'Beninese', 'Bhutanese', 'Bolivian', 'Bosnian', 'Brazilian', 'British', 'Bruneian', 'Bulgarian', 'Burkinabe', 'Burmese', 'Burundian', 'Cameroonian', 'Canadian', 'Cape Verdean', 'Central African', 'Chadian', 'Chilean', 'Colombian', 'Comoran', 'Congolese', 'Costa Rican', 'Croatian', 'Cuban', 'Cypriot', 'Czech', 'Danish', 'Djibouti', 'Dominican', 'Dutch', 'East Timorese', 'Ecuadorean', 'Egyptian', 'Emirian', 'Equatorial Guinean', 'Eritrean', 'Estonian', 'Ethiopian', 'Fijian', 'Finnish', 'French', 'Gabonese', 'Gambian', 'Georgian', 'German', 'Ghanaian', 'Greek', 'Grenadian', 'Guatemalan', 'Guinea-Bissauan', 'Guinean', 'Guyanese', 'Haitian', 'Herzegovinian', 'Honduran', 'Hungarian', 'I-Kiribati', 'Icelander', 'Iranian', 'Iraqi', 'Irish', 'Israeli', 'Italian', 'Ivorian', 'Jamaican', 'Japanese', 'Jordanian', 'Kazakhstani', 'Kenyan', 'Kittian and Nevisian', 'Kuwaiti', 'Kyrgyz', 'Laotian', 'Latvian', 'Lebanese', 'Liberian', 'Libyan', 'Liechtensteiner', 'Lithuanian', 'Luxembourger', 'Macedonian', 'Malagasy', 'Malawian', 'Maldivan', 'Malian', 'Maltese', 'Marshallese', 'Mauritanian', 'Mauritian', 'Mexican', 'Micronesian', 'Moldovan', 'Monacan', 'Mongolian', 'Moroccan', 'Mosotho', 'Motswana', 'Mozambican', 'Namibian', 'Nauruan', 'Nepalese', 'New Zealander', 'Nicaraguan', 'Nigerian', 'Nigerien', 'North Korean', 'Northern Irish', 'Norwegian', 'Omani', 'Pakistani', 'Palauan', 'Panamanian', 'Papua New Guinean', 'Paraguayan', 'Peruvian', 'Polish', 'Portuguese', 'Qatari', 'Romanian', 'Russian', 'Rwandan', 'Saint Lucian', 'Salvadoran', 'Samoan', 'San Marinese', 'Sao Tomean', 'Saudi', 'Scottish', 'Senegalese', 'Serbian', 'Seychellois', 'Sierra Leonean', 'Slovakian', 'Slovenian', 'Solomon Islander', 'Somali', 'South African', 'South Korean', 'Spanish', 'Sudanese', 'Surinamer', 'Swazi', 'Swedish', 'Swiss', 'Syrian', 'Taiwanese', 'Tajik', 'Tanzanian', 'Thai', 'Togolese', 'Tongan', 'Trinidadian/Tobagonian', 'Tunisian', 'Turkish', 'Tuvaluan', 'Ugandan', 'Ukrainian', 'Uruguayan', 'Uzbekistani', 'Venezuelan', 'Welsh', 'Yemenite', 'Zambian', 'Zimbabwean', 'Other',
  ],
  MEDICAL_RIGHTS_CLAIM: [
    { translation: 'general.medicalRightsClaimInsuranceCompany', value: 'Insurance Company' },
    { translation: 'general.medicalRightsClaimOfficial', value: 'Official' },
    { translation: 'general.medicalRightsClaimSelfPayment', value: 'Self-Payment' },
  ],
  ALLERGIES_SELECT: [
    { label: 'general.noKnownAllergies', value: 'No Known Allergies' },
    { label: 'general.yes', value: 'Yes' },
  ],
  BLOOD_GROUP: [
    { label: 'A', value: 'A' },
    { label: 'B', value: 'B' },
    { label: 'O', value: 'O' },
    { label: 'AB', value: 'AB' },
  ],
  RHESUS: [
    { label: 'general.positive', value: 'Positive' },
    { label: 'general.negative', value: 'Negative' },
  ],
  ACTIVENESS: [
    { label: 'general.active', value: 'Active' },
    { label: 'general.inactive', value: 'Inactive' },
  ],
  TEST_MODEL: {
    name: 'Keith',
    Occupation: 'PO',
  },
  TRANSFEROPTIONS: [
    { value: 'Credit', text: 'custom.credit' },
    { value: 'membershipPoint', text: 'report.membershipPoint' },
    { value: 'virtualCurrency', text: 'setting.inventoryType.virtualCurrency' },
  ],
  PATIENT_FORM: {
    givenId: '',
    name: '',
    nric: '',
    nricType: '',
    doctor: '',
    title: '',
    occupation: '',
    departmentName: '',
    jobPosition: '',
    countryOfBirth: '',
    gender: 'N',
    maritalStatus: '',
    nationality: '',
    dateOfBirth: '',
    startDate: '',
    shift: '',
    race: '',
    literacy: '',
    religion: '',
    postal: '',
    address: '',
    unit: '',
    email: '',
    telephone: '',
    regionCode: '',
    mobile: '',
    district: '',
    subDistrict: '',
    sameAsFormalAddress: '',
    presentTelephone: '',
    presentPostal: '',
    presentAddress: '',
    presentUnit: '',
    presentProvince: '',
    presentDistrict: '',
    presentSubDistrict: '',
    officeAddress: '',
    officeTelNo: '',
    emergencyContacts: [{
      nextOfKin: '',
      nextOfKinRelationship: '',
      nextOfKinRelationshipOthers: '',
      nextOfKinEmail: '',
      nextOfKinPhone: '',
    }],
    drugAllergiesSelect: '',
    drugAllergies: '',
    foodAllergiesSelect: '',
    foodAllergies: '',
    medication: '',
    currentMedication: '',
    medicalComplains: '',
    foodSymptom: '',
    drugSymptom: '',
    bloodGroup: '',
    rhesus: '',
    tags: [],
    signature: '',
    signatureDate: '',
    note: '',
    alerts: '',
    activeness: 'Active',
    questionnaireFormData: {
      have_you_seen: [], // need this to be set initially to array so its not treated as boolean
      medicalProblemYes: [], // map with schema default form data
    },
    adultRegistrationFormData: {},
    childRegistrationFormData: {},
    corpInsurance: [],
    familyMembers: [],
    referral: '',
    referredBy: '',
    others: '',
    doctorReferral: '',
    province: '',
    test: '',
    medicalRightsClaim: [],
    bgrimmConsent: {
      photographed: null,
      disclosed: '',
      disclosedOthers: '',
      finRepPatientSig: '',
      finRepWitness1Sig: '',
      finRepDate: '',
      finRepWitness2Sig: '',
      interpreterStatement: '',
      interpreterName: '',
      interpreterSig: '',
      patientRepSig: '',
      patientRepRel: '',
      patientRepSigDate: '',
      patientRepID: '',
      patientRepContact: '',
      patientNotConsentReason: '',
    },
    bgrimmConsentV2: {
      patientSigDate: '',
      authorisedPersonName: '',
      identificationCardNo: '',
      identificationCardExpiry: '',
      driverLicenceNo: '',
      driverLicenceExpiry: '',
      othersNo: '',
      othersExpiry: '',
      patientUnder18: '',
      patientUnfit: '',
      patientUnfitReason: '',
    },
    bgrimmHQ: {
      pregnant: '',
      hasReceipt: null,
    },
    bgrimmfinRepPatientSig: '',
    bgrimmfinRepWitness1Sig: '',
    bgrimmfinRepWitness2Sig: '',
    bgrimmInterpreterSig: '',
    bgrimmPatientRepSig: '',
    bgrimmPatientSig: '',
    bgrimmAuthorisedPersonSig: '',
    localTitle: '',
    localName: '',
  },
  PATIENT_REFERREDBY: [
    { label: 'patientReferredBy.advertisement', value: 'Advertisement' },
    { label: 'patientReferredBy.closeToHome', value: 'Close to Home/Work' },
    { label: 'patientReferredBy.doctorReferral', value: 'Doctor Referral' },
    { label: 'patientReferredBy.family', value: 'Family' },
    { label: 'patientReferredBy.friend', value: 'Friend' },
    { label: 'patientReferredBy.ispecially', value: 'I specially contacted my doctor who has previously treated me' },
    { label: 'patientReferredBy.internet', value: 'Internet' },
    { label: 'patientReferredBy.magazine', value: 'Magazine' },
    { label: 'patientReferredBy.newspaper', value: 'News Paper' },
    { label: 'patientReferredBy.publicTalksSeminars', value: 'Public Talks/Seminars' },
    { label: 'patientReferredBy.socialMedia', value: 'Social Media' },
    { label: 'patientReferredBy.internalMarketing', value: 'internal Marketing' },
    { label: 'patientReferredBy.others', value: 'Others' },
  ],
  PATIENT_REFERREDBY_OC: [
    { label: 'patientReferredBy.google', value: 'Google' },
    { label: 'patientReferredBy.facebook', value: 'Facebook' },
    { label: 'patientReferredBy.instagram', value: 'Instagram' },
    { label: 'patientReferredBy.youtube', value: 'YouTube' },
    { label: 'patientReferredBy.friendsFamily', value: 'Friends/Family' },
    { label: 'patientReferredBy.others', value: 'Others' },
  ],
  PATIENT_REFERREDBY_TCM: [
    { label: 'patientReferredBy.personalReferral', value: 'Personal Referral' },
    { label: 'patientReferredBy.google', value: 'Google' },
    { label: 'patientReferredBy.website', value: 'Website' },
    { label: 'patientReferredBy.socialMedia', value: 'Social Media' },
    { label: 'patientReferredBy.insurancePersonalCorporate', value: 'Insurance (Personal/corporate)' },
  ],
  PATIENT_REFERREDBY_OTHERS: 'Others',
  PATIENT_REFERREDBY_DOCTOR: 'Doctor Referral',
  PATIENT_REFERREDBY_PERSONAL_REFERRAL: 'Personal Referral',
  PATIENT_REFERREDBY_PERSONAL_INSURANCE_PERSONAL: 'Insurance (Personal/corporate)',
  PAYMENT_MODE_OPTIONS: {
    cash: 'Cash',
    paynow: 'PayNow',
    paylah: 'PayLah',
    union_pay: 'Union Pay',
    offset_deposit: 'Offset-Deposit',
    wirecard: 'Wirecard',
    apple_pay: 'Apple Pay',
    ali_pay: 'AliPay',
    wechat_pay: 'WeChat Pay',
    nets: 'NETS',
    mastercard: 'MasterCard',
    visa: 'Visa',
    amex: 'Amex',
    paypal: 'Paypal',
    cheque: 'Cheque',
    bank_transfer: 'Bank Transfer',
    giro: 'GIRO',
    online_payment: 'Online Payment',
    refund: 'Refund',
    credit_redeem: 'Credit Redeem',
    package_transfer: 'Package Transfer',
    bad_debts: 'Bad Debts',
    diners: 'Diners',
    jcb: 'JCB',
    others: 'Others',
    na: 'N/A',
  },
  INVENTORY_TYPES: {
    Medicine: 'setting.inventoryType.medicine',
    Consumables: 'setting.inventoryType.consumables',
    Expendables: 'setting.inventoryType.expendables',
    Procedure: 'setting.inventoryType.procedure',
    Therapy: 'setting.inventoryType.therapy',
    Teleconsult: 'setting.inventoryType.teleconsult',
    Package: 'setting.inventoryType.package',
    Bundle: 'setting.inventoryType.bundle',
    Investigation: 'setting.inventoryType.investigation',
    Referral: 'setting.inventoryType.referral',
    Injection: 'setting.inventoryType.injection',
    Vaccination: 'setting.inventoryType.vaccination',
    Misc: 'setting.inventoryType.misc',
    Credit: 'setting.inventoryType.credit',
    'Virtual Currency': 'setting.inventoryType.virtualCurrency',
    Compounded: 'setting.inventoryType.compounded',
    Product: 'setting.inventoryType.product',
    'Nursing Procedure': 'setting.inventoryType.nursingProcedure',
    Consultation: 'setting.inventoryType.consultation',
    Laboratory: 'setting.inventoryType.laboratory',
    Radiology: 'setting.inventoryType.radiology',
    'Professional Fees Consult': 'setting.inventoryType.professionalFeesConsult',
    'Professional Fees Procedures': 'setting.inventoryType.professionalFeesProcedures',
    Facilities: 'setting.inventoryType.facilities',
    'Health Screening': 'setting.inventoryType.healthScreening',
    'Order Set': 'setting.inventoryType.orderSet',
    Scanning: 'setting.inventoryType.scanning',
  },
  INVENTORY_TYPES_MAKUANG: {
    Wyn: 'setting.inventoryType.wyn',
  },
  IMPORT_INVENTORY_TYPES_MAKUANG: {
    Wyn: 'Wyn',
  },
  IMPORT_INVENTORY_TYPES: {
    Medicine: 'Medicine',
    Consumables: 'Consumables',
    Expendables: 'Expendables',
    Procedure: 'Procedure',
    Therapy: 'Therapy',
    Teleconsult: 'Teleconsult',
    Package: 'Package',
    Bundle: 'Bundle',
    Investigation: 'Investigation',
    Referral: 'Referral',
    Injection: 'Injection',
    Vaccination: 'Vaccination',
    Misc: 'Misc',
    Credit: 'Credit',
    'Virtual Currency': 'Virtual Currency',
    Compounded: 'Compounded',
    Product: 'Product',
    'Nursing Procedure': 'Nursing Procedure',
    Consultation: 'Consultation',
    Laboratory: 'Laboratory',
    Radiology: 'Radiology',
    'Professional Fees Consult': 'Professional Fees Consult',
    'Professional Fees Procedures': 'Professional Fees Procedures',
    Facilities: 'Facilities',
    'Health Screening': 'Health Screening',
    'Order Set': 'Order Set',
    Scanning: 'Scanning',
  },
  SUPPORTED_BONUS_INVENTORY_TYPES: [
    'Procedure',
    'Therapy',
    'Teleconsult',
    'Nursing Procedure',
    'Consultation',
  ],
  INVENTORY_UOM: {
    AMP: 'AMP',
    BAG: 'BAG',
    BOT: 'BOT',
    BOX: 'BOX',
    CAN: 'CAN',
    CAP: 'CAP',
    CC: 'CC',
    DOSE: 'DOSE',
    FOIL: 'FOIL',
    GAL: 'GAL',
    GM: 'GM',
    LOZ: 'LOZ',
    ML: 'ML',
    OVU: 'OVU',
    PA: 'PA',
    PAK: 'PAK',
    PC: 'PC',
    PESS: 'PESS',
    SA: 'SA',
    SET: 'SET',
    SUP: 'SUP',
    SYR: 'SYR',
    TAB: 'TAB',
    TB: 'TB',
    VIA: 'VIA',
    克: '克',
    精克: '精克',
    两: '两',
    斤: '斤',
    公斤: '公斤',
    钱: '钱',
    分: '分',
    锭: '锭',
    罐: '罐',
    箱: '箱',
    份: '份',
    次: '次',
    块: '块',
    个: '个',
    条: '条',
    对: '对',
    只: '只',
    杯: '杯',
  },
  INVENTORY_UOM_CN_TR: {
    粒: '粒',
    片: '片',
    滴: '滴',
    ml: 'ml',
    支: '支',
    cm: 'cm',
    包: '包',
    丸: '丸',
    袋: '袋',
    瓶: '瓶',
    盒: '盒',
    噴: '噴',
  },
  INVOICE_FIELD: {
    LINEITEM: {
      AFTER_TAX_PRICE: 'afterTaxPrice',
      QTY: 'qty',
      PRICE: 'price',
      DISCOUNT: 'discount',
      DISCOUNT_TYPE: 'discountType',
      TAX: 'tax',
      DESCRIPTION: 'description',
      INDICATION: 'indication',
      INDICATIONLOCAL: 'indicationLocal',
      INSTRUCTION: 'instruction',
      INSTRUCTIONLOCAL: 'instructionLocal',
      INSTRUCTIONINFO: 'instructionInfo',
      PRECAUTION1: 'precaution1',
      PRECAUTION1LOCAL: 'precaution1Local',
      PRECAUTION2: 'precaution2',
      PRECAUTION2LOCAL: 'precaution2Local',
      DOSAGE: 'dosage',
      DOSAGELOCAL: 'dosageLocal',
      LABEL: 'label',
      EXPIRY: 'expiry',
      SELECTEDBATCH: 'selectedBatch',
      REDEEMED_POINT: 'redeemedPoint',
      REDEEM_QTY: 'redeemQty',
      CONSULTANTS: 'consultants',
      THERAPISTS: 'therapists',
      PROVIDERS: 'providers',
      DURATION: 'duration',
    },
    ROUNDING_ENABLED: 'roundingEnabled',
  },
  ORDER_FIELD: {
    LINEITEM: {
      PURCHASING_UNIT_ORDERED: 'purchasingUnitOrdered',
      QTY_ORDERED: 'qtyOrdered',
      QTY: 'qty',
      UNIT_PRICE: 'price',
      BATCH_NO: 'batch',
      EXPIRY: 'expiry',
      AMT: 'amount',
    },
    ROUNDING_ENABLED: 'roundingEnabled',
  },
  CLINIC_ROLES: {
    provider: {
      VALUE: 'Provider',
      EQUIV: 'Doctor',
      LABEL: 'setting.providerForm.doctorName',
      LOCAL_LABEL: 'setting.providerForm.doctorLocalName',
      ID: 'setting.providerForm.doctor',
    },
    therapist: {
      VALUE: 'Therapist',
      EQUIV: 'Therapist',
      LABEL: 'setting.providerForm.therapistName',
      LOCAL_LABEL: 'setting.providerForm.therapistLocalName',
      ID: 'setting.providerForm.therapist',
    },
    consultant: {
      VALUE: 'Consultant',
      EQUIV: 'Consultant',
      LABEL: 'setting.providerForm.consultantName',
      LOCAL_LABEL: 'setting.providerForm.consultantLocalName',
      ID: 'setting.providerForm.consultant',
    },
  },
  CORPORATE_TYPES: {
    Corporate: 'Corporate',
    Insurance: 'Insurance',
    Hospital: 'Hospital',
  },
  CLINIC_TYPE: {
    Clinic: 'Clinic',
    Retail: 'Retail',
    Salon: 'Salon',
  },
  CORPORATE_TYPES_LIST: [
    { text: 'general.corporate', value: 'Corporate' },
    { text: 'general.insurancecompay', value: 'Insurance' },
    { text: 'general.hospital', value: 'Hospital' },
    { text: 'setting.none', value: 'None' },
  ],
  APPOINTMENT_STATUSES: {
    Scheduled: 'scheduled',
    Attended: 'attended',
    Cancelled: 'cancelled',
    NoShow: 'noShow',
    Available: 'Available',
    Confirmed: 'confirmed',
    Completed: 'completed',
    Approved: 'approved',
    Rejected: 'rejected',
  },
  APPOINTMENT_TYPE: {
    TELE_PATIENT_REMOTE: 'general.teleConsultPatientRemote',
    TELE_PROVIDER_REMOTE: 'general.teleConsultProviderRemote',
    NORMAL: 'general.normal',
  },
  OT_APPOINTMENT_STATUSES: {
    Pending: 'pending',
    AwaitingInvestigations: 'awaitingInvestigations',
    NoSlot: 'noSlotAvailable',
    Scheduled: 'scheduled',
  },
  OT_BOOKING_STATUSES: {
    PENDING: 'general.otBookingPending',
    APPROVED: 'general.otBookingApproved',
    AWAITING: 'general.otBookingAwaitingInvestigation',
    DECLINED: 'general.otBookingDeclined',
  },
  OT_SCHEDULE_STATUSES: {
    SCHEDULED: 'general.otSchedScheduled',
    CALLED_FOR: 'general.otSchedCalledFor',
    PRE_OP: 'general.otSchedPreOp',
    INDUCTION: 'general.otSchedInduction',
    KNIFE_SKIN: 'general.otSchedKnifeToSkin',
    OP_END: 'general.otSchedOpEnd',
    REVERSAL: 'general.otSchedReversal',
    OUT_OF_OT: 'general.otSchedOutOfOT',
    POST_OP_RECOVERY: 'general.otSchedPostOPRecovery',
    CLEANING: 'general.otSchedCleaning',
    COMPLETE: 'general.otSchedComplete',
  },
  YESNO: [
    { value: true, text: 'Yes', i18nId: 'general.yes' },
    { value: false, text: 'No', i18nId: 'general.no' },
  ],
  LETTER_BUILDER_HELPER: {
    PATIENT: [
      { value: '', text: '', disabled: true },
      { value: '{patient.title}', text: 'setting.letterPatient.title' },
      { value: '{patient.name}', text: 'setting.letterPatient.name' },
      { value: '{patient.nric}', text: 'setting.letterPatient.nric' },
      { value: '{patient.givenId}', text: 'setting.letterPatient.givenId' },
      { value: '{patient.localName}', text: 'general.localName' },
      { value: '{patient.localTitle}', text: 'general.localTitle' },
      { value: '{patient.age}', text: 'setting.letterPatient.age' },
    ],
    DATE: [
      { value: '', text: '', disabled: true },
      { value: '{date.today_date}', text: "Today's Date" },
      { value: '{date.one_day_later}', text: 'Date (1 Day Later)' },
      { value: '{date.three_days_later}', text: 'Date (3 Days Later)' },
    ],
    DATE_GENERAL: [
      { value: '{date.today_date}', text: 'setting.letterDate.todaydate' },
      { value: '{date.today_date_en}', text: 'setting.letterDate.todaydateEN' },
    ],
    DATE_BUSINESS_DAYS_ONLY: [
      { value: '{date.one_b_day_later}', text: 'setting.letterDate.businessdayAfter1' },
      { value: '{date.three_b_days_later}', text: 'setting.letterDate.businessdayAfter2' },
      { value: '{date.five_b_days_later}', text: 'setting.letterDate.businessdayAfter3' },
    ],
    DATE_ALL_DAYS: [
      { value: '{date.one_day_later}', text: 'setting.letterDate.alldayLater1' },
      { value: '{date.three_days_later}', text: 'setting.letterDate.alldayLater3' },
      { value: '{date.five_days_later}', text: 'setting.letterDate.alldayLater5' },
      { value: '{date.two_weeks_later}', text: 'setting.letterDate.alldayWeek2' },
      { value: '{date.one_month_later}', text: 'setting.letterDate.alldayMonth1' },
      { value: '{date.two_months_later}', text: 'setting.letterDate.alldayMonth2' },
      { value: '{date.three_months_later}', text: 'setting.letterDate.alldayMonth3' },
      { value: '{date.six_months_later}', text: 'setting.letterDate.alldayMonth6' },
    ],
    DOCTOR: [
      { value: '{provider.name}', text: 'setting.letterAttendingDr.name' },
      { value: '{provider.givenId}', text: 'setting.letterAttendingDr.givenId' },
      { value: '{provider.role}', text: 'setting.letterAttendingDr.role' },
      { value: '{provider.licenseNumber}', text: 'setting.letterAttendingDr.mcrNumber' },
      { value: '{provider.email}', text: 'setting.letterAttendingDr.email' },
      { value: '{provider.mobile}', text: 'setting.letterAttendingDr.mobile' },
    ],
    CLINIC: [
      { value: '{clinic.name}', text: 'setting.name' },
      { value: '{clinic.address}', text: 'custom.address' },
      { value: '{clinic.phoneNumber}', text: 'general.contact' },
    ],
    CLINIC_UAT: [
      { value: '{clinic.name}', text: 'setting.name' },
      { value: '{clinic.address}', text: 'custom.address' },
      { value: '{clinic.phoneNumber}', text: 'general.contact' },
      { value: '{config.clinicLocalName}', text: 'setting.clinicLocalName' },
      { value: '{config.clinicLocalAddress}', text: 'setting.clinicLocalAddress' },
    ],
    REFERRAL: [
      { value: '{referral.name}', text: 'setting.letterReferralInfo.name' },
      { value: '{referral.category}', text: 'setting.letterReferralInfo.category' },
      { value: '{referral.description}', text: 'setting.letterReferralInfo.description' },
      { value: '{referral.address}', text: 'setting.letterReferralInfo.address' },
      { value: '{referral.telephone}', text: 'setting.letterReferralInfo.contact' },
      { value: '{referral.fax}', text: 'setting.letterReferralInfo.fax' },
      { value: '{referral.email}', text: 'setting.letterReferralInfo.email' },
    ],
    CAL_NO_MC_DAYS: [
      { value: '{date.from_date}', text: 'setting.letterDate.fromDate' },
      { value: '{date.from_date_en}', text: 'setting.letterDate.fromDateEN' },
      { value: '{date.to_date}', text: 'setting.letterDate.toDate' },
      { value: '{date.to_date_en}', text: 'setting.letterDate.toDateEN' },
      { value: '{date.days}', text: 'setting.letterDate.numberOfDays' },
    ],
  },
  CONFIG_INVENTORY: [
    {
      label: 'Allow expendables type of inventory to be sellable',
      field: 'expendablesAreSellable',
      i18nId: 'setting.expendablesAreSellable',
    },
  ],
  CONFIG_INVENTORY_CATEGORYFIELDS: [{
    label: 'Type',
    field: 'type',
    tdClass: 'vcenter',
    i18nId: 'general.type',
  },
  {
    label: 'Category',
    field: 'category',
    tdClass: 'vcenter',
    i18nId: 'general.category',
  },
  {
    label: 'Actions',
    field: 'action',
    width: '100px',
    thClass: 'text-center',
    tdClass: 'text-center vcenter',
    i18nId: 'general.action',
  },
  ],
  CONFIG_INVENTORY_SKIN_REGIMEN_REMARK_FIELDS: [{
    label: 'Remarks',
    field: 'remark',
    tdClass: 'vcenter',
    i18nId: 'general.remarks',
  },
  {
    label: 'Actions',
    field: 'action',
    width: '100px',
    thClass: 'text-center',
    tdClass: 'text-center vcenter',
    i18nId: 'general.action',
  }],
  CONFIG_INVOICE_CATEGORYFIELDS: [{
    label: 'Type',
    field: 'type',
    tdClass: 'vcenter',
    i18nId: 'general.type',
  },
  {
    label: 'Category',
    field: 'category',
    tdClass: 'vcenter',
    i18nId: 'general.category',
  },
  {
    label: 'Combined',
    field: 'combined',
    width: '100px',
    thClass: 'text-center',
    tdClass: 'text-center vcenter',
    i18nId: 'general.combined',
  },
  ],
  CONFIG_PATIENT_MANDATORYFIELDS: [
    // {
    //   label: 'Full Name',
    //   field: 'fullName',
    //   i18nId: 'setting.patientName',
    // },
    {
      label: 'Mobile Number',
      field: 'mobNumber',
      i18nId: 'general.mobile',
    },
    {
      label: 'NRIC',
      field: 'nric',
      i18nId: 'general.idDocNumber',
    },
    {
      label: 'Email Address',
      field: 'emailAdd',
      i18nId: 'general.emailAddress',
    },
    {
      label: 'Date of Birth',
      field: 'dob',
      i18nId: 'general.dateOfBirth',
    },
    {
      label: 'Drug Allergies',
      field: 'drugAllergies',
      i18nId: 'general.drugAllergy',
    },
    {
      label: 'Nationality',
      field: 'nationality',
      i18nId: 'general.nationality',
    },
    {
      label: 'Food Allergies',
      field: 'foodAllergies',
      i18nId: 'general.foodAllergy',
    },
    {
      label: 'Residential Address',
      field: 'resAdd',
      i18nId: 'general.address',
    },
    {
      label: 'Patient Signature',
      field: 'patientSig',
      i18nId: 'setting.patientSignature',
    },
    {
      label: 'Corporate / Insurance',
      field: 'corpInsurance',
      i18nId: 'general.corpInsurance',
    },
    {
      label: 'Patient Id',
      field: 'givenId',
      i18nId: 'general.patientId',
    },
    {
      label: 'Patient Gender',
      field: 'gender',
      i18nId: 'general.gender',
    },
    {
      label: 'Country of Birth',
      field: 'countryOfBirth',
      i18nId: 'general.countryOfBirth',
    },
    {
      label: 'Province/State',
      field: 'province',
      i18nId: 'general.provinceState',
    },
    {
      label: 'Referred By',
      field: 'referredBy',
      i18nId: 'general.referredBy',
    },
  ],
  CONFIG_PATIENT_REGISTRATION_OPTIONS: [
    {
      label: 'Show clinic logo',
      field: 'showClinicLogo',
      i18nId: 'setting.showClinicLogo',
    },
    {
      label: 'Mobile Number to be unique',
      field: 'uniqueMobileNumber',
      i18nId: 'setting.uniqueMobileNumber',
    },
    {
      label: 'Prefix Patient ID with Clinic Code',
      field: 'prefixPatientIdWithClinicCode',
      i18nId: 'setting.prefixPatientIdWithClinicCode',
    },
    {
      label: 'Zero Pad Patient ID',
      field: 'zeroPaddPatientID',
      i18nId: 'setting.zeroPaddPatientID',
    },
    {
      label: 'Serialize Patient ID by clinic Code',
      field: 'serializePatientID',
      i18nId: 'setting.serializePatientID',
    },
  ],
  CONFIG_PATIENT_VITALSFIELDS: [{
    label: 'Code',
    field: 'code',
    width: '90px',
    i18nId: 'setting.code',
  },
  {
    label: 'Name',
    field: 'name',
    i18nId: 'general.name',
  },
  {
    label: 'Unit',
    field: 'unit',
    i18nId: 'general.unit',
  },
  {
    label: 'Other Code',
    field: 'extCode',
    i18nId: 'general.otherCode',
  },
  {
    label: 'Active',
    field: 'active',
    i18nId: 'general.active',
  },
  {
    label: 'Mandatory',
    field: 'mandatory',
    i18nId: 'general.mandatory',
  },
  {
    label: 'Actions',
    field: 'action',
    width: '100px',
    thClass: 'text-center',
    tdClass: 'text-center vcenter',
    i18nId: 'general.action',
  },
  ],
  CONFIG_INTEGRATED_TEST_STATUS_HEADER: [
    {
      label: 'Code',
      field: 'code',
      i18nId: 'setting.code',
    },
    {
      label: 'Pre-Status Action Name (optional)',
      field: 'labelName',
      i18nId: 'general.preStatusActionName',
    },
    {
      label: 'Name',
      field: 'name',
      i18nId: 'general.name',
    },
    // {
    //     label: 'Symbols',
    //     field: 'icon',
    //     i18nId: 'general.symbols',
    // },
    {
      label: 'Actions',
      field: 'action',
      width: '100px',
      thClass: 'text-center',
      tdClass: 'text-center vcenter',
      i18nId: 'general.action',
    },
  ],
  CONFIG_INVENTORY_PRINTPURCHASEORDERFIELDS: [
    {
      label: 'Supplier Name',
      field: 'supplierName',
      i18nId: 'order.supplierName',
    },
    {
      label: 'Supplier Address',
      field: 'supplierAddress',
      i18nId: 'order.supplierAddress',
    },
    {
      label: 'Clinic Name',
      field: 'clinicName',
      i18nId: 'setting.clinicName',
    },
    {
      label: 'Clinic Address',
      field: 'clinicAddress',
      i18nId: 'setting.address',
    },
    {
      label: 'Purchase Order Number',
      field: 'purchaseOrderNumber',
      i18nId: 'order.purchaseOrderNo',
    },
    {
      label: 'Purchase Order Created Date',
      field: 'purchaseOrderCreatedDate',
      i18nId: 'order.purchaseOrderCreatedDate',
    },
    {
      label: 'Item Rate',
      field: 'itemRate',
      i18nId: 'order.itemRate',
    },
    {
      label: 'Tax Rate',
      field: 'taxRate',
      i18nId: 'general.taxRate',
    },
    {
      label: 'Line Item Amount',
      field: 'lineItemAmount',
      i18nId: 'order.lineItemAmount',
    },
    {
      label: 'Subtotal, Tax, and Total Amount',
      field: 'subtotalTaxAndTotalAmount',
      i18nId: 'order.subtotalTaxAndTotalAmount',
    },
    {
      label: 'Notes',
      field: 'notes',
      i18nId: 'general.notes',
    },
  ],
  CONFIG_PATIENT_TAGS: [
    {
      label: 'Name',
      field: 'name',
      i18nId: 'general.name',
    },
    {
      label: 'Symbols',
      field: 'icon',
      i18nId: 'general.symbols',
    },
    {
      label: 'Actions',
      field: 'action',
      width: '100px',
      thClass: 'text-center',
      tdClass: 'text-center vcenter',
      i18nId: 'general.action',
    },
  ],
  CONFIG_PATIENT_PRINTLABELFIELDS: [
    {
      label: 'Clinic Name',
      field: 'clinicName',
      i18nId: 'setting.clinicName',
    },
    {
      label: 'Patient Date of Birth',
      field: 'patientDOB',
      i18nId: 'setting.dateOfBirth',
    },
    {
      label: 'Clinic Address',
      field: 'clinicAddress',
      i18nId: 'setting.address',
    },
    {
      label: 'Patient ID',
      field: 'patientID',
      i18nId: 'general.patientId',
    },
    {
      label: 'Patient Name',
      field: 'patientName',
      i18nId: 'general.patientName',
    },
    {
      label: 'Patient Sex',
      field: 'patientSex',
      i18nId: 'setting.gender',
    },
    {
      label: 'Patient NRIC/FIN',
      field: 'nricfin',
      i18nId: 'setting.idDocNumber',
    },
    {
      label: 'Nationality',
      field: 'nationality',
      i18nId: 'setting.nationality',
    },
    {
      label: 'Test',
      field: 'patientTest',
      i18nId: 'general.patientTest',
    },
    {
      label: 'Patient Age',
      field: 'age',
      i18nId: 'setting.patientAge',
    },
    {
      label: 'Patient Address',
      field: 'address',
      i18nId: 'general.patientAddress',
    },
    {
      label: 'Mobile Number',
      field: 'mobile',
      i18nId: 'general.mobile',
    },
  ],
  CONFIG_PATIENT_PRINTCONSULTNOTEFIELDS: [
    {
      label: 'Clinic Logo',
      field: 'clinicLogo',
      i18nId: 'setting.logo',
    },
    {
      label: 'Clinic Name',
      field: 'clinicName',
      i18nId: 'setting.clinicName',
    },
    {
      label: 'Clinic Address',
      field: 'clinicAddress',
      i18nId: 'setting.address',
    },
    {
      label: 'Patient Address',
      field: 'patientAddress',
      i18nId: 'general.patientAddress',
    },
    {
      label: 'Doctor Name',
      field: 'doctorName',
      i18nId: 'general.doctorName',
    },
    {
      label: 'Therapist Name',
      field: 'therapistName',
      i18nId: 'general.therapistName',
    },
    {
      label: 'Patient Name',
      field: 'patientName',
      i18nId: 'general.patientName',
    },
    {
      label: 'Patient NRIC',
      field: 'patientNRIC',
      i18nId: 'general.patientNRIC',
    },
    {
      label: 'Patient Date of Birth',
      field: 'patientDOB',
      i18nId: 'general.dateOfBirth',
    },
    {
      label: 'Patient Gender',
      field: 'patientGender',
      i18nId: 'general.patientGender',
    },
    {
      label: 'Patient Nationality',
      field: 'patientNationality',
      i18nId: 'general.nationality',
    },
    {
      label: 'Medical Services',
      field: 'medicalServices',
      i18nId: 'general.medicalServices',
    },
    {
      label: 'Visit Date',
      field: 'visitDate',
      i18nId: 'general.visitDate',
    },
  ],
  CONFIG_PATIENT_PRINTLETTERHEADERFIELDS: [{
    label: 'Clinic Logo',
    field: 'clinicLogo',
    i18nId: 'setting.logo',
  },
  {
    label: 'Clinic Name',
    field: 'clinicName',
    i18nId: 'setting.clinicName',
  },
  {
    label: 'Clinic Address',
    field: 'clinicAddress',
    i18nId: 'setting.address',
  },
  {
    label: 'Clinic Phone',
    field: 'clinicPhone',
    i18nId: 'setting.telephone',
  },
  {
    label: "Today's Date",
    field: 'todayDate',
    i18nId: 'setting.todayDate',
  },
  {
    label: "Today's Date in BE",
    field: 'todayDateBE',
    i18nId: 'setting.todayDateBE',
  },
  {
    label: 'Printed Date and Time',
    field: 'printedDateTime',
    i18nId: 'setting.printedDateTime',
  },
  {
    label: 'Patient ID',
    field: 'patientID',
    i18nId: 'general.patientId',
  },
  {
    label: 'Patient Name',
    field: 'patientName',
    i18nId: 'general.patientName',
  },
  {
    label: 'Patient NRIC/FIN',
    field: 'nricfin',
    i18nId: 'setting.idDocNumber',
  },
  {
    label: 'Patient Sex',
    field: 'patientSex',
    i18nId: 'setting.gender',
  },
  {
    label: 'Patient Date of Birth',
    field: 'patientDOB',
    i18nId: 'setting.dateOfBirth',
  },
  {
    label: 'Clinic Local Name',
    field: 'clinicLocalName',
    i18nId: 'setting.clinicLocalName',
  },
  {
    label: 'Clinic Local Address',
    field: 'clinicLocalAddress',
    i18nId: 'setting.clinicLocalAddress',
  },
  {
    label: 'Patient Local Name',
    field: 'patientLocalName',
    i18nId: 'general.patientLocalName',
  },
  {
    label: 'Patient Age',
    field: 'patientAge',
    i18nId: 'general.patientAge',
  },
  ],
  CONFIG_PATIENT_PRINTLETTERFOOTERFIELDS: [{
    label: 'Clinic Name',
    field: 'clinicName',
    i18nId: 'setting.clinicName',
  },
  {
    label: 'Clinic Address',
    field: 'clinicAddress',
    i18nId: 'setting.address',
  },
  {
    label: 'Clinic Phone',
    field: 'clinicPhone',
    i18nId: 'setting.telephone',
  },
  {
    label: "Today's Date",
    field: 'todayDate',
    i18nId: 'setting.todayDate',
  },
  {
    label: "Today's Date in BE",
    field: 'todayDateBE',
    i18nId: 'setting.todayDateBE',
  },
  {
    label: 'Printed Date and Time',
    field: 'printedDateTime',
    i18nId: 'setting.printedDateTime',
  },
  {
    label: 'Patient ID',
    field: 'patientID',
    i18nId: 'general.patientId',
  },
  {
    label: 'Patient Name',
    field: 'patientName',
    i18nId: 'general.patientName',
  },
  {
    label: 'Patient NRIC/FIN',
    field: 'nricfin',
    i18nId: 'setting.idDocNumber',
  },
  {
    label: 'Patient Sex',
    field: 'patientSex',
    i18nId: 'setting.gender',
  },
  {
    label: 'Patient Date of Birth',
    field: 'patientDOB',
    i18nId: 'setting.dateOfBirth',
  },
  {
    label: 'Clinic Local Name',
    field: 'clinicLocalName',
    i18nId: 'setting.clinicLocalName',
  },
  {
    label: 'Clinic Local Address',
    field: 'clinicLocalAddress',
    i18nId: 'setting.clinicLocalAddress',
  },
  {
    label: 'Patient Local Name',
    field: 'patientLocalName',
    i18nId: 'general.patientLocalName',
  },
  {
    label: 'Patient Age',
    field: 'patientAge',
    i18nId: 'general.patientAge',
  },
  ],
  CONFIG_PATIENT_PRINTPACKAGEFIELDS: [
    {
      label: 'Clinic Logo',
      field: 'clinicLogo',
      i18nId: 'setting.logo',
    },
  ],
  CONFIG_PATIENT_PRINTPRESCRIPTIONFIELDS: [
    {
      label: 'Clinic Logo',
      field: 'clinicLogo',
      i18nId: 'setting.logo',
    },
    {
      label: 'Clinic Name',
      field: 'clinicName',
      i18nId: 'setting.clinicName',
    },
    {
      label: 'Clinic Address',
      field: 'clinicAddress',
      i18nId: 'setting.address',
    },
    {
      label: 'Name',
      field: 'patientName',
      i18nId: 'prescriptionConfig.patientName',
    },
    {
      label: 'Gender',
      field: 'patientGender',
      i18nId: 'prescriptionConfig.patientGender',
    },
    {
      label: 'Age',
      field: 'patientAge',
      i18nId: 'prescriptionConfig.patientAge',
    },
    {
      label: 'Weight',
      field: 'patientWeight',
      i18nId: 'prescriptionConfig.patientWeight',
    },
    {
      label: 'Tel',
      field: 'patientTelephone',
      i18nId: 'prescriptionConfig.patientTelephone',
    },
    {
      label: 'Patient ID',
      field: 'patientID',
      i18nId: 'prescriptionConfig.patientId',
    },
    {
      label: 'VN',
      field: 'patientVN',
      i18nId: 'prescriptionConfig.patientVN',
    },
    {
      label: 'Service Type',
      field: 'serviceType',
      i18nId: 'prescriptionConfig.serviceType',
    },
    {
      label: 'Diagnosis',
      field: 'diagnosis',
      i18nId: 'prescriptionConfig.diagnosis',
    },
    {
      label: 'Skin Test',
      field: 'patientSkinTest',
      i18nId: 'prescriptionConfig.patientSkinTest',
    },
    {
      label: 'Date',
      field: 'invoiceDate',
      i18nId: 'prescriptionConfig.invoiceDate',
    },
    {
      label: 'Allergies',
      field: 'allergies',
      i18nId: 'prescriptionConfig.allergies',
    },
  ],
  CONFIG_INVOICE_PRINTFIELDS: [{
    label: 'Clinic Logo',
    field: 'clinicLogo',
    i18nId: 'setting.logo',
  },
  {
    label: 'Doctor Name',
    field: 'docName',
    i18nId: 'setting.providerName',
  },
  {
    label: 'Invoice Date in BE',
    field: 'invoiceDateBE',
    i18nId: 'setting.invoiceDateBE',
  },
  {
    label: 'Clinic Name (Local)',
    field: 'clinicLocalName',
    i18nId: 'setting.clinicLocalName',
  },
  {
    label: 'Clinic Address',
    field: 'clinicAdd',
    i18nId: 'setting.address',
  },
  {
    label: 'Clinic Address (Local)',
    field: 'clinicLocalAddress',
    i18nId: 'setting.clinicLocalAddress',
  },
  {
    label: 'Doctor Qualifications',
    field: 'docQual',
    i18nId: 'setting.providerQualifications',
  },
  {
    label: 'Patient Name',
    field: 'patientName',
    i18nId: 'general.patientName',
  },
  {
    label: 'Patient Name (Local)',
    field: 'patientLocalName',
    i18nId: 'setting.patientLocalName',
  },
  {
    label: 'NRIC',
    field: 'nric',
    i18nId: 'general.nric',
  },
  {
    label: 'Patient ID',
    field: 'patientGivenIdFull',
    i18nId: 'general.patientId',
  },
  {
    label: 'Patient Address',
    field: 'patientAdd',
    i18nId: 'setting.patientAddress',
  },
  {
    label: 'Patient Phone No.',
    field: 'patientPhoneNo',
    i18nId: 'setting.patientPhoneNo',
  },
  {
    label: 'Therapist Name',
    field: 'therapistName',
    i18nId: 'setting.therapistName',
  },
  {
    label: 'Diagnosis',
    field: 'diagnosis',
    i18nId: 'general.diagnosis',
  },
  {
    label: 'Description of Line Items',
    field: 'lineItemsDesc',
    i18nId: 'setting.lineItemDescription',
  },
  {
    label: 'Item Batch',
    field: 'batch',
    i18nId: 'setting.itemBatch',
  },
  {
    label: 'Tax Registration Number',
    field: 'regNumber',
    i18nId: 'setting.gstRegNo',
  },
  {
    label: 'Payment Time',
    field: 'paymentTime',
    i18nId: 'setting.paymentTime',
  },
  {
    label: 'Notes',
    field: 'notes',
    i18nId: 'general.notes',
  },
  {
    label: 'Invoice Footer',
    field: 'footer',
    i18nId: 'setting.invoiceFooter',
  },
  {
    label: 'Footer - Clinic/Hospital',
    field: 'clinicHospital',
    i18nId: 'setting.footerClinicHospital',
  },
  {
    label: 'Footer - Patient Signature',
    field: 'patientSignature',
    i18nId: 'setting.footerPatientSignature',
  },
  {
    label: 'Redeemed Point',
    field: 'membership',
    i18nId: 'general.membershipPointBalance',
  },
  {
    label: 'Virtual Currency',
    field: 'virtualCurrency',
    i18nId: 'general.virtualCurrencyBalance',
  }, {
    label: 'Outstanding Balance',
    field: 'ostBalance',
    i18nId: 'general.outstandingBalance',
  },
  ],
  CONFIG_INVOICE_CORPORATE_PRINTFIELDS: [{
    label: 'Clinic Logo',
    field: 'clinicLogo',
    i18nId: 'setting.logo',
  },
  {
    label: 'Clinic Name (Local)',
    field: 'clinicLocalName',
    i18nId: 'setting.clinicLocalName',
  },
  {
    label: 'Doctor Name',
    field: 'docName',
    i18nId: 'setting.providerName',
  },
  {
    label: 'Clinic Address',
    field: 'clinicAdd',
    i18nId: 'setting.address',
  },
  {
    label: 'Clinic Address (Local)',
    field: 'clinicLocalAddress',
    i18nId: 'setting.clinicLocalAddress',
  },
  {
    label: 'Invoice Date in BE',
    field: 'invoiceDateBE',
    i18nId: 'setting.invoiceDateBE',
  },
  {
    label: 'Doctor Qualifications',
    field: 'docQual',
    i18nId: 'setting.providerQualifications',
  },
  {
    label: 'Patient Name (Local)',
    field: 'patientLocalName',
    i18nId: 'setting.patientLocalName',
  },
  {
    label: 'Patient Address',
    field: 'patientAdd',
    i18nId: 'setting.patientAddress',
  },
  {
    label: 'Therapist Name',
    field: 'therapistName',
    i18nId: 'setting.therapistName',
  },
  {
    label: 'Diagnosis',
    field: 'diagnosis',
    i18nId: 'general.diagnosis',
  },
  {
    label: 'Description of Line Items',
    field: 'lineItemsDesc',
    i18nId: 'setting.lineItemDescription',
  },
  {
    label: 'Tax Registration Number',
    field: 'regNumber',
    i18nId: 'setting.gstRegNo',
  },
  {
    label: 'Notes',
    field: 'notes',
    i18nId: 'general.notes',
  },
  {
    label: 'Invoice Footer',
    field: 'footer',
    i18nId: 'setting.invoiceFooter',
  },
  {
    label: 'Footer - Clinic/Hospital',
    field: 'clinicHospital',
    i18nId: 'setting.footerClinicHospital',
  },
  {
    label: 'Footer - Patient Signature',
    field: 'patientSignature',
    i18nId: 'setting.footerPatientSignature',
  },
  {
    label: 'Company Name',
    field: 'companyName',
    i18nId: 'general.companyName',
  },
  {
    label: 'Company Address',
    field: 'companyAddress',
    i18nId: 'general.companyAddressConfig',
  },
  ],
  CONFIG_INVOICE_ROUNDING_SELECTION: {
    NONE: 'setting.none',
    ROUND0P05: 'setting.roundToNearest5Cent',
    ROUND1P00: 'setting.roundToNearestDollar',
    ROUND1U00: 'setting.roundUpToNearestDollar',
    ROUND0D10: 'setting.roundDownToNearest10Cent',
    ROUND1D00: 'setting.roundDownToNearestDollar',
  },
  CONFIG_INVOICE_ROUNDING_SELECTION_FOR_LINEITEM_TOTAL: {
    ROUNDTOTAL: 'setting.roundToTotal',
    ROUNDLINEITEM: 'setting.roundToLineItem',
  },
  CONFIG_APPOINTMENT_MANDATORYFIELDS: [{
    label: 'Category',
    field: 'category',
    i18nId: 'general.category',
  },
  {
    label: 'Medical Service',
    field: 'medService',
    i18nId: 'general.serviceType',
  },
  {
    label: 'Room',
    field: 'room',
    i18nId: 'general.room',
  },
  {
    label: 'Provider',
    field: 'provider',
    i18nId: 'general.provider',
  },
  {
    label: 'Therapist',
    field: 'therapist',
    i18nId: 'general.therapist',
  },
  {
    label: 'Consultant',
    field: 'consultant',
    i18nId: 'general.consultant',
  },
  {
    label: 'Appointment Details',
    field: 'apptmntDetails',
    i18nId: 'general.appointmentDetails',
  },
  ],
  CONFIG_APPOINTMENT_HOVERFIELDS: [{
    label: 'Appointment Details',
    field: 'apptmntDetails',
    i18nId: 'general.appointmentDetails',
  },
  {
    label: 'Category',
    field: 'category',
    i18nId: 'general.category',
  },
  {
    label: 'Type',
    field: 'type',
    i18nId: 'general.type',
  },
  {
    label: 'Service',
    field: 'medService',
    i18nId: 'general.serviceType',
  },
  {
    label: 'Room',
    field: 'room',
    i18nId: 'general.room',
  },
  {
    label: 'Provider',
    field: 'provider',
    i18nId: 'general.provider',
  },
  {
    label: 'Therapist',
    field: 'therapist',
    i18nId: 'general.therapist',
  },
  {
    label: 'Consultant',
    field: 'consultant',
    i18nId: 'general.consultant',
  },
  {
    label: 'Secondary Provider ',
    field: 'secondaryProvider',
    i18nId: 'general.secondaryProvider',
  },
  {
    label: 'Organiser',
    field: 'organiser',
    i18nId: 'general.organiser',
  },
  ],
  CONFIG_APPOINTMENT_FIELDS_TO_SYNC: [
    {
      label: 'Appointment Details',
      field: 'apptDetails',
      i18nId: 'general.appointmentDetails',
    },
    {
      label: 'Category',
      field: 'category',
      i18nId: 'general.category',
    },
    {
      label: 'Type',
      field: 'apptType',
      i18nId: 'general.type',
    },
    {
      label: 'Medical Service',
      field: 'medService',
      i18nId: 'general.serviceType',
    },
    {
      label: 'Room',
      field: 'room',
      i18nId: 'general.room',
    },
    {
      label: 'Provider',
      field: 'provider',
      i18nId: 'general.provider',
    },
    {
      label: 'Therapist',
      field: 'therapist',
      i18nId: 'general.therapist',
    },
    {
      label: 'Consultant',
      field: 'consultant',
      i18nId: 'general.consultant',
    },
    {
      label: 'Secondary Provider',
      field: 'secondaryProvider',
      i18nId: 'general.secondaryProvider',
    },
    {
      label: 'Organiser',
      field: 'organiser',
      i18nId: 'general.organiser',
    },
  ],
  CONFIG_APPOINTMENT_CATEGORYFIELDS: [{
    label: 'Name',
    field: 'name',
    tdClass: 'vcenter',
    i18nId: 'general.name',
  },
  {
    label: 'Description',
    field: 'desc',
    tdClass: 'vcenter',
    i18nId: 'general.description',
  },
  {
    label: 'Color',
    field: 'color',
    thClass: 'text-center',
    tdClass: 'text-center vcenter',
    i18nId: 'setting.color',
  },
  {
    label: 'Icon',
    field: 'icon',
    thClass: 'text-center',
    tdClass: 'text-center vcenter',
    i18nId: 'setting.icon',
  },
  {
    label: 'Actions',
    field: 'action',
    width: '100px',
    thClass: 'text-center',
    tdClass: 'text-center vcenter',
    i18nId: 'general.action',
  },
  ],
  CONFIG_APPOINTMENT_DRAGONCARE_CATEGORY_FIELDS: [
    {
      label: 'Name',
      field: 'name',
      tdClass: 'vcenter',
      i18nId: 'general.name',
    },
    {
      label: 'Description',
      field: 'desc',
      tdClass: 'vcenter',
      i18nId: 'general.description',
    },
    {
      label: 'Remote',
      field: 'isRemote',
      tdClass: 'vcenter',
      i18nId: 'general.remote',
    },
    {
      label: 'Actions',
      field: 'action',
      width: '100px',
      thClass: 'text-center',
      tdClass: 'text-center vcenter',
      i18nId: 'general.action',
    },
  ],
  CONFIG_INVOICE_REQUEST_APPROVAL_FIELDS: [
    {
      label: 'Dispensing',
      field: 'dispense',
      i18nId: 'general.dispense',
    },
    {
      label: 'Remove',
      field: 'remove',
      i18nId: 'general.remove',
    },
    {
      label: 'Increase Qty',
      field: 'increaseQty',
      i18nId: 'setting.increaseQty',
    },
    {
      label: 'Reduce Qty',
      field: 'reduceQty',
      i18nId: 'setting.reduceQty',
    },
    {
      label: 'Price',
      field: 'price',
      i18nId: 'general.price',
    },
    {
      label: 'Discount',
      field: 'discount',
      i18nId: 'general.discount',
    },
  ],
  NOTIFICATION_TEMPLATE_VARIABLES: [{
    value: '{patient.name}',
    text: 'setting.medServiceForm.patientName',
  },
  {
    value: '{patient.localName}',
    text: 'setting.medServiceForm.patientLocalName',
  },
  {
    value: '{appointment.schedule}',
    text: 'setting.medServiceForm.appointmentSchedule',
  },
  {
    value: '{appointment.appointmentScheduleBE}',
    text: 'setting.medServiceForm.appointmentScheduleBE',
  },
  {
    value: '{appointment.service}',
    text: 'setting.medServiceForm.appointmentService',
  },
  {
    value: '{clinic.name}',
    text: 'setting.medServiceForm.clinicName',
  },
  {
    value: '{clinic.localName}',
    text: 'setting.medServiceForm.clinicLocalName',
  },
  {
    value: '{clinic.address}',
    text: 'setting.medServiceForm.clinicAddress',
  },
  {
    value: '{clinic.localAddress}',
    text: 'setting.medServiceForm.clinicLocalAddress',
  },
  {
    value: '{clinic.phone}',
    text: 'setting.medServiceForm.clinicPhone',
  },
  {
    value: '{appointment.confirmPaymentLink}',
    text: 'setting.medServiceForm.appointmentConfirmPaymentLink',
  },
  {
    value: '{appointment.confirmLink}',
    text: 'setting.medServiceForm.appointmentConfirmLink',
  },
  {
    value: '{patient.registration}',
    text: 'setting.medServiceForm.patientRegLink',
  },
  {
    value: '{appointment.appointmentQRCodeLink}',
    text: 'setting.medServiceForm.appointmentQRCodeLink',
  },
  ],
  QRCODE_TEMPLATE_VARIABLES: [{
    value: '{patient.name}',
    text: 'setting.medServiceForm.patientName',
  },
  {
    value: '{clinic.name}',
    text: 'setting.medServiceForm.clinicName',
  },
  {
    value: '{clinic.address}',
    text: 'setting.medServiceForm.clinicAddress',
  },
  {
    value: '{clinic.phone}',
    text: 'setting.medServiceForm.clinicPhone',
  },
  {
    value: '{appointment.appointmentInvitedLink}',
    text: 'setting.medServiceForm.appointmentInvitedLink',
  },
  ],
  MEMBERSHIP: {
    POINTS_DEDUCTION: {
      AUTO: 'AUTO',
      MANUAL: 'MANUAL',
    },
    ACTIVATION_TYPE: {
      MANUAL: 'MANUAL',
      SPENDING: 'SPENDING',
    },
    CALCULATION_PERIODS: {
      CURRENT_TIER_12_MONTHS: 'membership.calcPeriod12months', // translated
      // ROLLING_6_MONTHS: 'Rolling 6 Months',
      // ROLLING_12_MONTHS: 'Rolling 12 Months',
      // NO_QUALIFYING_PERIOD: 'No Qualifying Period',
      CALENDAR_YEAR: 'membership.calcPeriodCalYear', // translated
      MONTH_24: 'membership.calcPeriod24Month', // translated
      INVOICE: 'membership.onInvoice',
    },
    QUALIFICATION_TYPE: {
      POINT: 'POINT',
      CASH: 'CASH',
    },
    TRANSACTION_TYPES: {
      P: 'general.purchase',
      PROMO: 'membership.promotion',
      R: 'membership.redeemed',
      AU: 'membership.adjustUp',
      AD: 'membership.adjustDown',
      T: 'transferPoint.transfer',
      W: 'tableHeader.welcomePoints',
      TO: 'transferPoint.transferOut',
      TI: 'transferPoint.transferIn',
      VP: 'membership.voidPurchase',
      VPROMO: 'membership.voidPromotion',
      VR: 'membership.voidRedeem',
      VW: 'membership.voidWelcome',
      CREDIT_NOTE: 'membership.creditNote',
    },
    TRANSACTION_TYPES_NIKS: {
      P: 'general.purchase',
      PROMO: 'membership.promotion',
      R: 'membership.redeemed',
      AU: 'membership.adjustUp',
      AD: 'membership.adjustDown',
      T: 'transferPoint.transfer',
      W: 'tableHeader.welcomePointsNiks',
      TO: 'transferPoint.transferOut',
      TI: 'transferPoint.transferIn',
      VP: 'membership.voidPurchase',
      VPROMO: 'membership.voidPromotion',
      VR: 'membership.voidRedeem',
      VW: 'membership.voidWelcome',
      CREDIT_NOTE: 'membership.creditNote',
    },

    TEMPLATE_POINTS_OPTIONS: {
      PENM: 'membership.PENM',
      RPBL: 'membership.RPBL',
      P1ME: 'membership.P1ME',
      P2ME: 'membership.P2ME',
      P3ME: 'membership.P3ME',
      P4ME: 'membership.P4ME',
      P5ME: 'membership.P5ME',
      P6ME: 'membership.P6ME',
      PRNM: 'membership.PRNM',
    },
    TEMPLATE_TIERS_OPTIONS: {
      CURRENT_TIER: 'membership.currentTier',
      NEXT_TIER: 'membership.nextTier',
    },
    TEMPLATE_GENERAL_OPTIONS: {
      COMPANY_LOGO: 'setting.companyLogo',
      PATIENT_NAME: 'general.patientName',
      TITLE: 'general.title',
      NRIC: 'pharmacy.nric',
    },
    TEMPLATE_DATE_OPTIONS: {
      DAY_1: {
        D1BL: 'membership.D1BL',
        D3BL: 'membership.D3BL',
        D5BL: 'membership.D5BL',
        TODAY: 'membership.today',
      },
      DAY_2: {
        D1L: 'membership.D1L',
        D1W: 'membership.D1W',
        D1M: 'membership.D1M',
        D3M: 'membership.D3M',
      },
    },
    TEMPLATE_TRIGGER_DATE: {
      W1: '1 Week Before Expiry',
      W2: '2 Week Before Expiry',
      W3: '3 Week Before Expiry',
      M1: '1 Month Before Expiry',
    },
  },
  PHARMACY_MEDS_FIELDS: [{
    labelKey: 'pharmacy.colGivenId',
    field: 'medicine.givenId',
    tdClass: 'vcenter med-given-id',
  }, {
    labelKey: 'pharmacy.colPicture',
    field: 'medicine.thumbnailURL',
    thClass: 'text-center',
    tdClass: 'text-center vcenter',
    sortable: false,
  }, {
    labelKey: 'pharmacy.colMedName',
    field: 'medicine.name',
    tdClass: 'vcenter',
  }, {
    labelKey: 'pharmacy.colBatch',
    field: 'batch.number',
    thClass: 'text-center',
    tdClass: 'text-center vcenter',
  }, {
    labelKey: 'Bar code',
    field: 'Bar code',
    thClass: 'text-center',
    tdClass: 'text-center vcenter',
    sortable: false,
  }, {
    labelKey: 'pharmacy.colQuantity',
    field: 'quantity',
    thClass: 'text-center',
    tdClass: 'text-center vcenter',
    sortable: false,
  }, {
    labelKey: 'pharmacy.colStatus',
    field: 'status',
    thClass: 'text-center',
    tdClass: 'text-center vcenter',
  }, {
    labelKey: 'pharmacy.colAction',
    field: 'newStatus',
    thClass: 'text-center',
    tdClass: 'text-center vcenter',
    sortable: false,
  }, {
    labelKey: 'pharmacy.colStatusDate',
    field: 'statusDate',
    tdClass: 'vcenter',
  }, {
    labelKey: 'pharmacy.colLabel',
    field: 'label',
    thClass: 'text-center',
    tdClass: 'text-center vcenter',
    sortable: false,
  }, {
    labelKey: 'pharmacy.colPrint',
    field: 'print',
    thClass: 'text-center',
    tdClass: 'text-center vcenter',
    sortable: false,
  }],
  PHARMACY_STATUS_TYPES: [
    { value: 'Confirmed', i18nId: 'pharmacy.confirmed' },
    { value: 'Corrected', i18nId: 'pharmacy.corrected' },
    { value: 'Executed', i18nId: 'pharmacy.executed' },
    { value: 'Voided', i18nId: 'pharmacy.voided' },
  ],
  IPD_PHARMACY_STATUS_TYPES: [
    { value: 'CANCELLED', i18nId: 'pharmacy.cancelled' },
    { value: 'REQUESTED', i18nId: 'pharmacy.requested' },
    { value: 'EXECUTED', i18nId: 'pharmacy.executed' },
    { value: 'CLARIFY_AND_EXECUTED', i18nId: 'pharmacy.clarifiedExecuted' },
    { value: 'CLARIFY_AND_CANCELLED', i18nId: 'pharmacy.clarifiedCancelled' },
  ],
  IPD_PHARMACY_STATUS: {
    CANCELLED: 'CANCELLED',
    PENDING: 'REQUESTED',
    EXECUTED: 'EXECUTED',
    CLARIFY_AND_EXECUTED: 'CLARIFY_AND_EXECUTED',
    CLARIFY_AND_CANCELLED: 'CLARIFY_AND_CANCELLED',
  },
  IPD_PHARMACY_STATUS_LABEL: {
    CANCELLED: 'pharmacy.cancelled',
    REQUESTED: 'pharmacy.requested',
    EXECUTED: 'pharmacy.executed',
    CLARIFY_AND_EXECUTED: 'pharmacy.clarifiedExecuted',
    CLARIFY_AND_CANCELLED: 'pharmacy.clarifiedCancelled',
  },
  IPD_PHARMACY_ACTION_LABEL: {
    EXECUTED: 'pharmacy.execute',
    CLARIFY_AND_EXECUTED: 'pharmacy.clarifyExecute',
    CLARIFY_AND_CANCELLED: 'pharmacy.clarifyCancel',
  },
  IPD_PRESCRIPTION_STATUS: {
    ACTIVE: 'ACTIVE',
    REQUESTED: 'REQUESTED',
    CANCELLED: 'CANCELLED',
    STOPPED: 'STOPPED',
    COMPLETED: 'COMPLETED',
  },
  IPD_PRESCRIPTION_STATUS_LABEL: {
    ACTIVE: 'general.active',
    REQUESTED: 'pharmacy.requested',
    CANCELLED: 'pharmacy.cancelled',
    STOPPED: 'pharmacy.stopped',
    COMPLETED: 'general.completed',
  },
  IPD_PRESCRIPTION_CONTROLLED_STATUS: {
    PENDING: 'PENDING',
  },
  IPD_PRESCRIPTION_CONTROLLED_STATUS_LABEL: {
    PENDING: 'general.pending',
  },
  IPD_ADMINISTRATION_STATUS_LABEL: {
    all: 'general.all',
    administered: 'general.administered',
    notAdministered: 'general.notAdministered',
  },
  ADMINISTRATION_LOGS_STATUS_LABEL: {
    SERVED: 'Served',
    DELAYED: 'Delayed',
    MISSED: 'Missed',
    REFUSED: 'Refused',
    HELD: 'Held',
  },
  ADMINISTRATION_LOGS_STATUS: {
    SERVED: 'SERVED',
    DELAYED: 'DELAYED',
    MISSED: 'MISSED',
    REFUSED: 'REFUSED',
    HELD: 'HELD',
  },
  ANAESTHESIA_EVENTS_LABEL: {
    NIL: 'inpatient.nil',
    HYPOTENSION: 'inpatient.hypotension',
    ECG_ISCHAEMIA: 'inpatient.eCGIschaemia',
    ARRHYTHMIA: 'inpatient.arrhythmia',
    DUG_ERROR: 'inpatient.dugError',
    PERSISTENT_SP02: 'inpatient.persistentSp02',
    Hypothermia: 'inpatient.hypothermia',
    ALLERGIC_REACTION: 'inpatient.allergicReaction',
    ASPIRATION: 'inpatient.aspiration',
    BRONCHOSPASM: 'inpatient.bronchospasm',
    LARYGOSPASM: 'inpatient.larygospasm',
    FAILED_INTUBATION: 'inpatient.failedIntubation',
    DENTAL_DAMAGE: 'inpatient.dentalDamage',
    MULTIPLE_INTUBATION_ATTEMPTS: 'inpatient.multipleIntubationAttempts',
    UNPLANNED_ICU_ADMISSION: 'inpatient.unplannedICUadmission',
    CARDIAC_ARREST: 'inpatient.cardiacArrest',
    DEATH: 'inpatient.death',
  },
  ALDRETE_SCORE: {
    ASA2: 2,
    ASA1: 1,
    ASA0: 0,
    ASR2: 2,
    ASR1: 1,
    ASR0: 0,
    ASC2: 2,
    ASC1: 1,
    ASC0: 0,
    ASO22: 2,
    ASO21: 1,
    ASO20: 0,
    '': 0,
  },
  ALDRETE_SCORE_ACTIVITY_LABEL: {
    ASA2: 'postOperative.moveAllExtremities',
    ASA1: 'postOperative.moves2Extremeties',
    ASA0: 'postOperative.cannotMoveExtremities',
  },
  ALDRETE_SCORE_ACTIVITY_SCORE: {
    ASA2: 2,
    ASA1: 1,
    ASA0: 0,
  },
  ALDRETE_SCORE_RESPIRATIONS_LABEL: {
    ASR2: 'postOperative.breathesDeeply',
    ASR1: 'postOperative.dyspneicShollowLimitBreathing',
    ASR0: 'postOperative.apneic',
  },
  ALDRETE_SCORE_RESPIRATIONS_SCORE: {
    ASR2: 2,
    ASR1: 1,
    ASR0: 0,
  },
  ALDRETE_SCORE_CIRCULATION_LABEL: {
    ASC2: 'postOperative.preanesthiticLevelHigher20mmHg',
    ASC1: 'postOperative.preanesthiticLevelBetween2050mmHg',
    ASC0: 'postOperative.preanesthiticLevelHigher50mmHg',
  },
  ALDRETE_SCORE_CIRCULATION_SCORE: {
    ASC2: 2,
    ASC1: 1,
    ASC0: 0,
  },
  ALDRETE_SCORE_O2_SITURATION_LABEL: {
    ASO22: 'postOperative.roomAirHigher92Percent',
    ASO21: 'postOperative.oxygenLevelHigher90Percent',
    ASO20: 'postOperative.sautrationLess90PercentO2',
  },
  ALDRETE_SCORE_O2_SITURATION_SCORE: {
    ASO22: 2,
    ASO21: 1,
    ASO20: 0,
  },
  BROMAGE_SCALE_SCORE: {
    BS0: 0,
    BS1: 1,
    BS2: 2,
    BS3: 3,
    '': 0,
  },
  BROMAGE_SCALE_LABEL: {
    BS0: 'postOperative.ableToLiftLegs',
    BS1: 'postOperative.ableToFlexKnee',
    BS2: 'postOperative.ableToMoveFeet',
    BS3: 'postOperative.unableToMoveJoints',
  },
  DISCHARGE_CHECKLIST_LABEL: {
    DCHKL0: 'postOperative.awake',
    DCHKL1: 'postOperative.minimalNausea',
    DCHKL2: 'postOperative.vomitting',
    DCHKL3: 'postOperative.stableVitalSign',
    DCHKL4: 'postOperative.sustainedHeadlift',
    DCHKL5: 'postOperative.painScoreLess4',
    DCHKL6: 'postOperative.awa',
    DCHKL7: 'postOperative.noActiveBleeding',
    DCHKL8: 'postOperative.aldreteScore',
    DCHKL9: 'postOperative.BromageScale',
  },
  DISCHARGE_CHECKLIST: {
    DCHKL0: 'DCHKL0',
    DCHKL1: 'DCHKL1',
    DCHKL2: 'DCHKL2',
    DCHKL3: 'DCHKL3',
    DCHKL4: 'DCHKL4',
    DCHKL5: 'DCHKL5',
    DCHKL6: 'DCHKL6',
    DCHKL7: 'DCHKL7',
    DCHKL8: 'DCHKL8',
    DCHKL9: 'DCHKL9',
  },
  DISCHARGE_TO: {
    WARD: 'WARD',
    HD: 'HD',
    ICU: 'ICU',
  },
  WARD_INSTRUCTION_LABEL: {
    SPIRAL_EPIDURAL: 'spinalEpiduralGiven',
    UPPER_LOWER_LIMB: 'upperLowerLimbGiven',
  },
  WARD_INSTRUCTION: {
    SPIRAL_EPIDURAL: 'SPIRAL_EPIDURAL',
    UPPER_LOWER_LIMB: 'UPPER_LOWER_LIMB',
  },
  TASK_TYPE: {
    NORMAL: 'NORMAL',
    DRUG_APPROVAL: 'DRUG_APPROVAL',
  },
  DRUG_CLASSIFICATION_OPTION: {
    NORMAL: 'Normal',
    CLASSIFIED: 'Classified',
    OTC: 'OTC',
    Prescription: 'Prescription',
    Controlled: 'Controlled',
  },
  DRUG_CLASSIFICATION_OPTION_KH: {
    OTC: 'OTC',
    Prescription: 'Prescription',
    Controlled: 'Controlled',
  },
  DRUG_CLASSIFICATION: {
    NORMAL: 'NORMAL',
    CLASSIFIED: 'CLASSIFIED',
  },
  RULE_ENGINE_CONFIG: {
    PARAM_ACTION_LANG_MAP: {
      'Start Consult': 'setting.ruleEngineStartConsult',
      'End Consult': 'setting.ruleEngineEndConsult',
      'Start Treatment': 'setting.ruleEngineStartTreatment',
      'End Treatment': 'setting.ruleEngineEndTreatment',
      'Photo Taken': 'setting.ruleEnginePhotoTaken',
      Call: 'setting.ruleEngineCall',
      'Queue Number': 'setting.ruleEngineQueueNum',
      Invoice: 'setting.ruleEngineInvoice',
      Payment: 'setting.ruleEnginePayment',
      Patient: 'setting.ruleEnginePatient',
      Appointment: 'setting.ruleEngineAppointment',
      'Consult Note': 'setting.ruleEngineConsultNote',
      Vitals: 'setting.ruleEngineVitals',
      'New Task': 'setting.ruleEngineNewTask',
      'Added to Today\'s Queue': 'setting.ruleEngineAddTodayQueue',
      'Removed to Today\'s Queue': 'setting.ruleEngineRemTodayQueue',
      Created: 'setting.ruleEngineCreated',
      Activated: 'setting.ruleEngineActivated',
      Recorded: 'setting.ruleEngineRecorded',
    },
    CONDITION_LANG_MAP: {
      is: 'setting.ruleEngineCondIs',
      isnot: 'setting.ruleEngineCondIsNot',
    },
    TYPE_LANG_MAP: {
      Queue: 'setting.ruleEngineTypeQueue',
      General: 'setting.ruleEngineTypeGeneral',
    },
    SELECT_PARAMETERS: [
      { action: 'Start Consult', types: 'Queue' },
      { action: 'End Consult', types: 'Queue' },
      { action: 'Start Treatment', types: 'Queue' },
      { action: 'End Treatment', types: 'Queue' },
      { action: 'Photo Taken', types: 'Queue' },
      { action: 'Call', types: 'Queue' },
      { action: 'Queue Number', types: 'Queue' },
      { action: 'Invoice', types: 'Invoice' },
      { action: 'Payment', types: 'Invoice' },
      { action: 'Patient', types: 'General' },
      { action: 'Appointment', types: 'General' },
      { action: 'Consult Note', types: 'General' },
      { action: 'Vitals', types: 'General' },
      { action: 'New Task', types: 'General' },
    ],
    SELECT_ACTION: [
      { action: "Added to Today's Queue", types: 'Queue' },
      { action: "Removed to Today's Queue", types: 'Queue' },
      { action: 'Created', types: 'General' },
      { action: 'Activated', types: 'General' },
      { action: 'Recorded', types: 'General' },
    ],
    start_consult: 'Start Consult',
    end_consult: 'End Consult',
    start_treatment: 'Start Treatment',
    end_treatment: 'End Treatment',
    photo_taken: 'Photo Taken',
    call: 'Call',
    queueNumber: 'Queue Number',
    patient: 'Patient',
    invoice: 'Invoice',
    payment: 'Payment',
    appoitment: 'Appointment',
    consultNote: 'Consult Note',
    vitals: 'Vitals',
    newTask: 'New Task',
    addedQueue: "Added to Today's Queue",
    removedQueue: "Removed to Today's Queue",
    created: 'Created',
    activated: 'Activated',
    recorded: 'Recorded',
  },
  CONFIG_PAYMENT_MODES: [{
    label: 'Name',
    field: 'name',
    i18nId: 'general.name',
  },
  {
    label: 'Processing Value',
    field: 'processValue',
    i18nId: 'paymentMode.processValue',
    type: 'Number',
  },
  {
    label: 'Processing Type',
    field: 'processType',
    i18nId: 'paymentMode.processType',
  },
  {
    label: 'Active',
    field: 'hidden',
    width: '90px',
    thClass: 'text-center',
    tdClass: 'text-center vcenter',
    i18nId: 'general.active',
    sortable: false,
  },
  {
    label: 'Actions',
    field: 'action',
    width: '100px',
    thClass: 'text-center',
    tdClass: 'text-center vcenter',
    i18nId: 'general.action',
    sortable: false,
  },
  ],
  QUEUE_CALLNUMBER_STATUS: {
    APPT: 'APPT',
    URGENT: 'URGENT',
  },
  QUEUE_CALLNUMBER_PREFIX: {
    APPT: 'A',
    URGENT: 'U',
    '': '',
  },
  CAMPAIGN_PROMO_TYPES: {
    BUYXGETY: 'campaign.buyXGetX',
    DISCOUNT: 'general.discount',
    FREEGIFT: 'campaign.freeGift',
    COMPLEX: 'campaign.complex',
    BIRTHDAY_BONUS: 'campaign.birthdayBonus',
  },
  PATIENTS_QUANTITY_TYPES: {

    PERMONTH: 'campaign.perMonth',
    PERBIRTHMONTH: 'campaign.perBirthMonth',
    PERYEAR: 'campaign.perYear',
    NOLIMIT: 'campaign.noLimit',
  },
  CAMPAIGN_BUYXGETX_ITEMTYPES: {
    ANY: 'campaign.anyItem',
    ANY_MEDICINE: 'campaign.anyMedicine',
    ANY_CONSUMABLES: 'campaign.anyConsumables',
    ANY_EXPENDABLES: 'campaign.anyExpendables',
    ANY_PROCEDURE: 'campaign.anyProcedure',
    ANY_PACKAGE: 'campaign.anyPackage',
    ANY_BUNDLE: 'campaign.anyBundle',
    ANY_INVESTIGATION: 'campaign.anyInvestigation',
    ANY_REFERRAL: 'campaign.anyReferral',
    ANY_INJECTION: 'campaign.anyInjection',
    ANY_VACCINATION: 'campaign.anyVaccination',
    ANY_MISC: 'campaign.anyMisc',
    ANY_CREDIT: 'campaign.anyCredit',
    ANY_PRODUCT: 'campaign.anyProduct',
    SPECIFIED: 'campaign.specificItem',
  },
  CAMPAIGN_FIELDS: [{
    label: 'general.promotion',
    field: 'name',
    thClass: 'text-left',
    tdClass: 'text-left vcenter',
  }, {
    label: 'general.type',
    field: 'promoType',
    thClass: 'text-center',
    tdClass: 'text-center vcenter',
  }, {
    label: 'campaign.qtyLimit',
    field: 'quantityLimit',
    thClass: 'text-center',
    tdClass: 'text-center vcenter',
  }, {
    label: 'general.quantityAvailable',
    field: 'quantityAvailable',
    thClass: 'text-center',
    tdClass: 'text-center vcenter',
  }, {
    label: 'general.item',
    field: 'items',
    thClass: 'text-center',
    tdClass: 'text-center vcenter',
  }, {
    label: 'campaign.promoCode',
    field: 'promoCode',
    thClass: 'text-center',
    tdClass: 'text-center vcenter',
  }],
  CAMPAIGN_STATUS: {
    ACTIVE: 'general.active',
    ENDED: 'general.ended',
    UPCOMING: 'general.upcoming',
  },
  CAMPAIGN_ELIGIBILITY: {
    ALL: 'general.allCustomer',
    NONMEMBERS: 'general.nonMembersOnly',
    MEMBERS: 'general.membersOnly',
  },
  WAITLIST_STATUS: {
    Accepted: 'approved',
    Rejected: 'rejected',
    Pending: 'pending',
    Cancelled: 'cancelled',
  },
  WAITLIST_LABEL: {
    approved: 'Accepted',
    rejected: 'Rejected',
    pending: 'Pending',
    cancelled: 'Cancelled',
  },
  IMPORT_INVENTORY: {
    inventory: 'Inventory Type*',
    givenId: 'Given Id*',
    name: 'Inventory Name*',
    chineseName: 'Local Name*',
    description: 'Description*',
    purchasingUnit: 'Purchasing Unit', // Inventory Unit Conversion
    unit: 'Inventory Unit / Dispense Unit*',
    qtyOfInventoryUnitPerPurchasingUnit: 'Purchasing Contains*',
    price: 'Selling Price (Default)*',
    priceMin: 'Selling Price (min)*',
    cost: 'Cost Price*',
    category: 'Category*',
    defaultDispenseQty: 'Default Dispense Qty*',
    stickers: 'Default Label Qty*',
    drugClassification: 'Drug Classification*',
    brandName: 'Brand Name*',
    precaution1: 'Precaution 1*',
    precaution2: 'Precaution 2*',
    dosage: 'Default Dosage*',
    tax: 'Tax*',
    lowStockLimit: 'Low Stock Limit*',
    trackStock: 'Track Stock*',
    manufacturer: 'Manufacturer*',
    strength: 'Strength*',
    inactive: 'Inactive*',
    creditAmount: 'Credit Amount*',
    freeAmount: 'Free Amount*',
    purchasedAmount: 'Purchased Amount*',
    providerCommissionAmt: 'Provider Commission Amount*',
    providerCommissionType: 'Provider Commission Type*',
    therapistCommissionAmt: 'Therapist Commission Amount*',
    therapistCommissionType: 'Therapist Commission Type*',
    consultantCommissionAmt: 'Consultant Commission Amount*',
    consultantCommissionType: 'Consultant Commission Type*',
    consignment: 'Consignment*',
    manufacturingBarcode: 'Manufacturing Barcode*',
    accountingCode: 'Accounting Code*',
    minOrderQty: 'Minimum Order Quantity*',
    indication: 'Indication*',
    indicationLocal: 'Indication (Local)*',
    instruction: 'Instruction*',
    instructionLocal: 'Instruction (Local)*',
    dosageLocal: 'Dosage (Local)*',
    precaution1Local: 'Precaution 1 (Local)*',
    precaution2Local: 'Precaution 2 (Local)*',
    thaiBillingGroup: 'Thai Billing Group',
    location: 'Location',
    pinyin: 'Pinyin',
  },
  IMPORT_Employee_AS_Patient: {
    employeeID: 'Employee ID',
    employeeNameTh: 'Employee Name TH',
    employeeNameEN: 'Employee Name EN',
    confirmDate: 'Confirm Date',
    terminationDate: 'Termination Date',
    idCardNo: 'ID. Card No.',
    birthDate: 'Birth Date ',
    gender: 'Gender',
    benefitScheme1: 'Benefit scheme 1 ',
    corporate1: 'Corporate 1',
    benefitScheme2: 'Benefit scheme 2',
    corporate2: 'Corporate 2',
    email: 'Office Email',
    mobile: 'Mobile',
  },
  CSV_SAMPLE_EXPORT: [
    {
      inventory: 'Medicine',
      givenId: 'JDNJWJ',
      name: 'Sample Medicine',
      chineseName: '',
      description: 'Sample Medicine',
      purchasingUnit: 'BOX', // Inventory Unit Conversion
      unit: 'BOX',
      qtyOfInventoryUnitPerPurchasingUnit: '10',
      price: '350',
      priceMin: '350',
      cost: '300',
      category: 'Medicine',
      defaultDispenseQty: '10',
      stickers: '10',
      drugClassification: 'NORMAL',
      brandName: 'Sample Brand Name',
      precaution1: 'Test PRECAUTION 1',
      precaution2: 'Test PRECAUTION 2',
      dosage: 'Apply 1 1/2 AMP S - use as instructed',
      tax: '7',
      lowStockLimit: '10',
      trackStock: 'true',
      manufacturer: '',
      strength: '',
      inactive: 'false',
      creditAmount: '',
      freeAmount: '',
      purchasedAmount: '',
      providerCommissionAmt: '1',
      providerCommissionType: 'value',
      therapistCommissionAmt: '1',
      therapistCommissionType: 'percentage',
      consultantCommissionAmt: '1',
      consultantCommissionType: 'percentage',
      consignment: '',
      manufacturingBarcode: 'A12345',
      accountingCode: '',
      minOrderQty: 1,
      indication: '',
      indicationLocal: '',
      instruction: '',
      instructionLocal: '',
      dosageLocal: '',
      precaution1Local: '',
      precaution2Local: '',
      thaiBillingGroup: '1.1.1(3)',
      // remember to add new fields to exportCSV() at ImportInventory.vue!
    },
  ],
  COMMISSION_TYPE: {
    percentage: 'percentage',
    value: 'value',
  },
  TAG_ICON: [
    'thermometer-full',
    'gem',
    'exclamation-triangle',
    'lightbulb',
    'star',
    'bell',
    'asterisk',
    'bolt',
    'check-circle',
    'flag',
    'allergies',
    'eye',
    'fist-raised',
    'heart',
    'tags',
    'thumbs-up',
    'weight-hanging',
    'wheelchair',
    'user-slash',
    'running',
    'hand-holding-usd',
  ],
  MAX_DISPENSE_SEARCHRESULTS: 50,
  ORDER_SLIDER: 'ORDER_SLIDER',
  OT_INVOICE: 'OT_INVOICE',
  AREA_CLASSIFICATION: {
    OT: 'OT',
    ADMISSION: 'ADMISSION',
  },
  ADMISSION_STATUS: {
    PENDING: 'PENDING',
    FORM_ACCEPTED: 'FORM_ACCEPTED',
    PRE_ADMITTED: 'PRE_ADMITTED',
    ADMITTED: 'ADMITTED',
    LAMA: 'LAMA',
    TRANSFERRED: 'TRANSFERRED',
    PRE_DISCHARGE: 'PRE_DISCHARGE',
    DISCHARGE: 'DISCHARGE',
    AWAIT_PAYMENT: 'AWAIT_PAYMENT',
    PAYMENT_RECEIVED: 'PAYMENT_RECEIVED',
  },
  ADMISSION_STATUS_LABEL: {
    PRE_ADMITTED: 'Pre Admitted',
    ADMITTED: 'Admitted',
    LAMA: 'LAMA',
    TRANSFERRED: 'Transferred',
    PRE_DISCHARGE: 'Pre Discharge',
    AWAIT_PAYMENT: 'Awaiting Payment',
    PAYMENT_RECEIVED: 'Payment Received',
    DISCHARGE: 'Discharge',
  },
  BED_STATUS: {
    GWD: 'GWD',
    VIP: 'VIP',
    DS: 'DS',
    NURSERY: 'NURSERY',
    ICU: 'ICU',
    DELIVERY: 'DELIVERY',
    ISOLATION: 'ISLOATION',
  },
  BED_STATUS_LABEL: {
    GWD: 'GWD',
    VIP: 'VIP',
    DS: 'DS',
    NURSERY: 'Nursery',
    ICU: 'ICU',
    DELIVERY: 'Delivery',
    ISOLATION: 'Isolation',
  },
  BILLING_STATUS: {
    INSURANCE: 'INSURANCE',
    SELF_PAID: 'SELF_PAID',
    COMPANY: 'COMPANY',
    LG: 'LG',
    VIP: 'VIP',
    VVIP: 'VVIP',
    GOVT: 'GOVT',
  },
  NURSING_INPUTOUTPUT_SECTIONS: {
    inputIVFluid: {
      ivFluids: 'nursingIO.inputIVFluidIVFluids',
      oral: 'nursingIO.inputIVFluidOral',
      nasogastricFeeding: 'nursingIO.inputIVFluidNasogastricFeeding',
    },
    inputIVMed: {},
    inputBloodProduct: {},
    outputUrine: {},
    outputBowel: {},
    outputVomitous: {},
    outputDrainage: {},
  },
  BILLING_STATUS_LABEL: {
    INSURANCE: 'Insurance',
    SELF_PAID: 'Self Payment',
    COMPANY: 'Company',
    LG: 'LG',
    VIP: 'VIP',
    VVIP: 'VVIP',
    GOVT: 'Government',
  },
  INVOICE_STATUS_LABEL: {
    OUTSTANDING: 'general.corpInvOutstanding',
    FULLY_PAID: 'general.corpInvFullyPaid',
  },
  PAYMENT_STATUS_LABEL: {
    RECORDED: 'setting.ruleEngineRecorded',
    NOT_RECORDED: 'general.notRecorded',
  },
  TREATMENTS_FIELDS: [
    'suppression',
    'growthHormone',
    'fsh',
    'hcg',
    'lutealSupport',
    'letrozole',
    'procedures',
  ],
  FET_TREATMENTS_FIELDS: [
    'progynova',
    'fsh50iu',
    'sildegra',
    'evorelPatch',
    'endometrin',
    'imProgesterone',
    'procedures',
    'progesterone',
  ],
  IUI_TREATMENTS_FIELDS: [
    'clomid',
    'letrozole',
    'progynova2mg',
    'fshiuday',
    'duphaston',
    'endometrin',
    'cyclogest',
    'progesterone',
  ],
  TCM_CONSULTATION_STATUS: {
    DRAFT: 'Draft',
    FINALIZED: 'Finalized',
  },
  VISIT_RECORD_STATUS: {
    DRAFT: 'Draft',
    PUBLISHED: 'Published',
  },
  // TODO: should use full en abbreviation key
  TCM_ACU_CATEGORY: ['针灸'],
  UPLOAD_STATE: {
    PENDING: 'PENDING',
    PROCESSING: 'PROCESSING',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED',
    CANCELLED: 'CANCELLED',
  },
  LAB_TEST: {
    NATIONAL_ID_TYPES: {
      NIRC: 'nirc',
      PASSPORT: 'passport',
      FIN: 'fin',
    },
    TEST_TYPE: {
      GASTRO_CLEAR: 'GASTRO_CLEAR',
    },
  },
  CREDIT_MODES: {
    OFFSET: 'Offset',
    REFUND: 'Refund',
  },
  STATUS_SELECTION: {
    PENDING: 'Pending',
    USE: 'Use',
    DO_NOT_USE: 'DoNotUse',
  },
  BONUS_PACKAGE_GIVEN_ID: '_BONUS_PACKAGE',
  DRAGONCARE_PATIENT_SYSTEM_TAG: {
    NO_SHOW: {
      name: 'No Show',
      icon: 'user-slash',
    },
    MISSED_MULTIPLE_APPTS: {
      name: 'Missed Multiple Appointments',
      icon: 'running',
    },
    DEPOSIT_PAID: {
      name: 'Deposit Paid',
      icon: 'hand-holding-usd',
    },
  },
  SELECTED_OPTION_MODULES: {
    CRITERIA: 'criteria',
  },
  PRINT_STATUS: {
    PRINTING: 'PRINTING',
    PRINTED: 'PRINTED',
    FAILED: 'FAILED',
  },
  CHART_REPORT: {
    UPDATE_TYPE: {
      CREATE: 1,
      UPDATE: 2,
    },
    REPORT_TYPE: {
      ICSI: 'icsi',
      IUI: 'iui',
      STC: 'stc',
    },
    BASE_ICSI_REPORT_URL: '/icsi-report',
    BASE_STC_REPORT_URL: '/stc-report',
    BASE_IUI_REPORT_URL: '/iui-report',
  },
  BATCH_INVENTORY_TYPES: [
    'Medicine',
    'Wyn',
    'Consumables',
    'Expendables',
    'Product',
    'Vaccination',
  ],
  MAKUANG_REPORT_GROUP_BY: {
    DATE: 'DATE',
    CLINIC: 'CLINIC',
  },
});
